//mockdata

export const parkingData = {
    "vehicleNotesFI": "- Autolla on Helsingin kaupungin Z-pysäköintilupa. Lue lisää: http://www.24rent.fi/pysakointi-z-luvalla\"",
    "vehicleNotesEN": "",
    "parkingPermitValidUntil": "2023-05-01",
    "permitCityName": "Helsinki",
    "instructions": {
      "fi": {
        "startInstructions": "Voit pysäköidä autossa olevalla Z-luvalla varauksesi aikana ja sen päätteeksi Helsingin kaupungin hallinnoimille pysäköintipaikoille. Voit pysäköidä Z-luvalla myös Vantaalla ja Espoossa paikoille, jotka on erillisellä lisäkilvellä osoitettu yhteiskäyttöautoille.\n\nZ-lupa oikeuttaa pysäköimään\n\n- vähintään kahden tunnin aikarajoitetuille paikoille\n- yleisesti maksulliseksi merkitylle alueelle\n- asukas- ja yrityspysäköintipaikoille A-O\n- Z-lupapaikoille.\n\nHuomaa, ettet voi pysäköidä 60 minuutin tai alle 60 minuutin aikarajoitetuille paikoille.\n\nMuistathan, että Z-luvallista pysäköintiä koskevat normaalit liikenne- ja pysäköintisäännöt. Älä pysäköi pihoihin, porttikonkien tai suojateiden eteen tai vuokrausehtojemme mukaisesti alueelle, jossa on tai on 3 vuorokauden sisään voimaantuleva siirtokehotus.",
        "endInstructions": "Voit pysäköidä autossa olevalla Z-luvalla varauksesi päätteeksi Helsingin kaupungin hallinnoimille pysäköintipaikoille. Voit pysäköidä Z-luvalla myös Vantaalla ja Espoossa paikoille, jotka on erillisellä lisäkilvellä osoitettu yhteiskäyttöautoille.\n\nZ-lupa oikeuttaa pysäköimään\n- vähintään kahden tunnin aikarajoitetuille paikoille\n- yleisesti maksulliseksi merkitylle alueelle\n- asukas- ja yrityspysäköintipaikoille A-O\n- Z-lupapaikoille.\n\nHuomaa, ettet voi pysäköidä 60 minuutin tai alle 60 minuutin aikarajoitetuille paikoille.\n\nMuistathan, että Z-luvallista pysäköintiä koskevat normaalit liikenne- ja pysäköintisäännöt. Älä pysäköi pihoihin, porttikonkien tai suojateiden eteen tai vuokrausehtojemme mukaisesti alueelle, jossa on tai on 3 vuorokauden sisään voimaantuleva siirtokehotus."
      },
      "en": {
        "startInstructions": "The car has a Z parking permit that allows you to park both during and at the end of your reservation on all parking spaces managed by the city of Helsinki. You can also park in Vantaa and Espoo on parking spots marked with special signs for car sharing vehicles (yhteiskäyttöauto)\n\nWith the parking permit Z you can park on:\n\nTime-limited parking spaces with at least a two-hour restriction\nGeneral metered / pay and display parking spaces\nResidential or business parking spaces for permit holders A–O\nParking spaces for Z permit holders\n\nPlease note that you cannot park on time-limited parking spaces with a restriction for 60 minutes or less.\n\nPlease note that normal parking rules apply. Do not park on yards, in front of gateways or pedestrian crossings or on areas with an effective or upcoming request to move vehicles within three days (a Siirtokehotus sign).",
        "endInstructions": "The car has a Z parking permit that allows you to park at the end of your reservation on all parking spaces managed by the city of Helsinki. You can also park in Vantaa and Espoo on parking spots marked with special signs for car sharing vehicles (yhteiskäyttöauto)\n\nWith the parking permit Z you can park on:\n- Time-limited parking spaces with at least a two-hour restriction\n- General metered / pay and display parking spaces\n- Residential or business parking spaces for permit holders A–O\n- Parking spaces for Z permit holders\n\nPlease note that you cannot park on time-limited parking spaces with a restriction for 60 minutes or less.\n\nPlease note that normal parking rules apply. Do not park on yards, in front of gateways or pedestrian crossings or on areas with an effective or upcoming request to move vehicles within three days (a \"Siirtokehotus\" sign)."
      }
    }
  };

  export const trailData =  [
        [
            24.943687,
            60.164825
        ],
        [
            24.943718,
            60.164761
        ],
        [
            24.943785,
            60.164722
        ],
        [
            24.943869,
            60.164688
        ],
        [
            24.943951,
            60.164463
        ],
        [
            24.944122,
            60.164295
        ],
        [
            24.944187,
            60.164257
        ],
        [
            24.944387,
            60.164204
        ],
        [
            24.945312,
            60.164227
        ],
        [
            24.945513,
            60.16423
        ]
    ];

export const searchData =
    {
        "count": 82,
        "vehicles": [
            {
                "id": "876",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 5779.545681244371,
                "homeLocationData": {
                    "id": 2206,
                    "address": "Elimäenkatu 32",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.197791,
                        "longitude": 24.947791
                    },
                    "descriptions": {
                        "en": "Pelican Self Storage parking. No parking in front of gates or doors, only in the space reserved for 24Rent. Please leave a 1m space between the car and the wall. Pelican staff does not participate in car rental.",
                        "fi": "Auto sijaitsee Pelican Self Storagen sisäpihalla. Ei pysäköintiä ovien, nosto-ovien tai porttien eteen. Jätä 1 m väliä seinään. Pysäköinti 24Rentille merkityllä paikalla. "
                    },
                    "fullAddress": "Elimäenkatu 32, 00520 Helsinki",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Vallila - Pelican",
                    "postalCode": "00520",
                    "notes": "Pelicanin henkilökunta ei osallistu vuokraukseen. ",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2000,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 27500,
                        "towHitch": 900,
                        "unlimitedKilometers": 2000,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 25500,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": {
                        "additionalDriver": 0,
                        "cancellationlnsurance": 0,
                        "discount": 2900,
                        "export": 0,
                        "fiveHundredGramsCOTwo": 0,
                        "freeKilometers": 100,
                        "freeKilometersType": "perDay",
                        "handTruck": null,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramSCOTwo" : 0,
                        "includesHastinessFee" : false,
                        "includesPickupTimeFee" : false,
                        "includesReturnTimeFee": false,
                        "lowDeductib1e": 0,
                        "priceperKilometer": 0,
                        "savingopportunities" : [
                            "virka-aikaan arkipäivisin",
                            "varaamalla auton Iomakauden ulkopuolella"
                        ],
                        "sevenHundredGramsCOTwo": 0,
                        "tirernsurance": 0,
                        "totalprice": 0,
                        "towHitch" :null,
                        "unlimitedKilometers": 0,
                        "unlimitedKilometersForPolos" :null,
                        "unlimitedOneWayKilometers" :null,
                        "vehicleprice": 0,
                        "windshieldlnsurance": 0
                    },
                    "coupon": {
                        "category": "Kumppani",
                        "description": "Alennus: kokonaishinnasta max. 100.00%",
                        "effectiveFrom": null,
                        "effectiveUntil" :null,
                        "target": "total",
                        "type":"percentage"
                    },
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "automaattivaihteinen"
                ],
                "vehicleData": {
                    "id": 876,
                    "acriss": "",
                    "airbagCount": 1,
                    "brakedTowingCapacity": 2500,
                    "class": 1,
                    "co2Emissions": 194,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 7,
                    "currentMileage": 39674,
                    "currentVoltage": 11.96,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 103,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": true,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Kumpulantie 17, 00520 Helsinki",
                    "hybridity": "none",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1274,
                    "modelYear": 2020,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "ZNE-445",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "kitka",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 50,
                        "dimensions": {
                            "trunkDepth": 345,
                            "trunkHeight": 196,
                            "trunkVolume": 11,
                            "trunkWidth": 181,
                            "vehicleHeight": 270,
                            "vehicleLength": 600,
                            "vehicleWidth": 210
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "VW",
                        "modelacriss": "",
                        "name": "Crafter aut",
                        "descr": "VW Crafter on erittäin mukava ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. \n\nVarustettu pysäköintitutkilla ja peruutuskameralla. ",
                        "descren": "VW Crafter is very comfortable and high quality option for bigger transportation needs.\n\nEquipped with rear view camera and parking sensors.\n",
                        "notes": "- Huomioi ajoneuvon korkeus vajaa 3m: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Automaattivaihteisto. Käynnistä jarrupoljin painettuna.\n\n- Mikäli joku ovista on raollaan, ei keskuslukitus lukitse ovia.\n\n- Jos ovet naksahtavat takaisin kiinni heti puhelimella avaamisen jälkeen, yritä uudelleen ja vedä kahvasti heti naksahduksen kuultuasi.",
                        "notesen": "- Almost 3 meters tall! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Automatic transmission. Press brake pedal while starting.\n\n- The doors are quite stiff to use. Please ensure that all doors are properly closed before locking them.\n\n- If the locks close right away when opened via portal, try again and immediately pull the handle when you hear the click. ",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 50,
                    "dimensions": {
                        "trunkDepth": 345,
                        "trunkHeight": 196,
                        "trunkVolume": 11,
                        "trunkWidth": 181,
                        "vehicleHeight": 270,
                        "vehicleLength": 600,
                        "vehicleWidth": 210
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "VW",
                    "modelacriss": "",
                    "name": "Crafter aut",
                    "descr": "VW Crafter on erittäin mukava ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. \n\nVarustettu pysäköintitutkilla ja peruutuskameralla. ",
                    "descren": "VW Crafter is very comfortable and high quality option for bigger transportation needs.\n\nEquipped with rear view camera and parking sensors.\n",
                    "notes": "- Huomioi ajoneuvon korkeus vajaa 3m: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Automaattivaihteisto. Käynnistä jarrupoljin painettuna.\n\n- Mikäli joku ovista on raollaan, ei keskuslukitus lukitse ovia.\n\n- Jos ovet naksahtavat takaisin kiinni heti puhelimella avaamisen jälkeen, yritä uudelleen ja vedä kahvasti heti naksahduksen kuultuasi.",
                    "notesen": "- Almost 3 meters tall! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Automatic transmission. Press brake pedal while starting.\n\n- The doors are quite stiff to use. Please ensure that all doors are properly closed before locking them.\n\n- If the locks close right away when opened via portal, try again and immediately pull the handle when you hear the click. ",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "525_50_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "525_50_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "525_50_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "525_50_4_large.webp"
                    }
                ]
            },
            {
                "id": "745",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 6015.376806827053,
                "homeLocationData": {
                    "id": 225,
                    "address": "Elimäenkatu 15",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.194718,
                        "longitude": 24.948917
                    },
                    "descriptions": {
                        "en": "Aimo Park Vallila on the higher parking level (https://www.24rent.fi/kulkuohje-aimo-parkeihin/). ",
                        "fi": "Aimo Park Vallila -parkkitalossa ylätasolla (-1) (kulkuohjeet: https://www.24rent.fi/kulkuohje-aimo-parkeihin/)."
                    },
                    "fullAddress": "Elimäenkatu 15, 00510 Helsinki",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Vallila - Aimo Park",
                    "postalCode": "00510",
                    "notes": "",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2000,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 26100,
                        "towHitch": 900,
                        "unlimitedKilometers": 1400,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 24100,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 745,
                    "acriss": "",
                    "airbagCount": 1,
                    "brakedTowingCapacity": 2500,
                    "class": 1,
                    "co2Emissions": 247,
                    "consumptionInCity": 12,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 2328,
                    "currentMileage": 42180,
                    "currentVoltage": 11.96,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2.3,
                    "enginePower": 110,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 6,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Töysänkatu 1, 00510 Helsinki",
                    "hybridity": "none",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1529,
                    "modelYear": 2020,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "YKN-777",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "kitka",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 63,
                        "dimensions": {
                            "trunkDepth": 303,
                            "trunkHeight": 189,
                            "trunkVolume": 11,
                            "trunkWidth": 176,
                            "vehicleHeight": 260,
                            "vehicleLength": 558,
                            "vehicleWidth": 240
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Renault",
                        "modelacriss": "",
                        "name": "Master",
                        "descr": "Hyvä valinta myös suurempiin ja vaativampiin kuljetustarpeisiin. \n\nVarusteina mm. vakionopeudensäädin, peruutustutka ja -kamera, navigaattori, mäkilähtöavustin ja Extended grip –järjestelmä, AUX- ja USB-liitännät, Bluetooth, älypuhelinpeilaus Android Auto + Apple CarPlay",
                        "descren": "Renault Master is good option for a bigger transportation needs. \n",
                        "notes": "- Sininen merkkivalo kertoo kylmästä moottorista. Valo sammuu kun moottori lämpenee. Autoa voi käyttää normaalisti.\n\n- Vältä käsijarrun käyttöä talviaikaan, etenkin varauksesi päätteeksi. Auton voi tasaisella jättää 1-vaihteelle ilman käsijarrua.\n\n- Renault-merkkisten autojen polttoainemittari näyttää usein täytenäkin vajaata. Tankkaa auto varauksesi päättyessä AINA täyteen ja säilytä kuitti. Jos epäilet tankanneesi enemmän kuin kulutit, täytä reklamaatio osoitteessa https://www.24rent.fi/polttoainereklamaatio.",
                        "notesen": "- Blue warning light means that engine is cold. Light turns off when engine heats up. You can use the van normally.\n\n- The fuel gauge in many Renault models may show inaccurate readings even when the tank is full. ALWAYS fill up the tank before you return the vehicle and keep the receipt. If you feel you needed to fill up more than you used, please submit a fuel complaint at https://www.24rent.fi/polttoainereklamaatio.\n\n- Renault Master may sometimes display the following warning lights: Injection fault or Check emissions/engine. These are due to incorrect sensor readings. If no other warnings are shown, you can drive the van as usual.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 63,
                    "dimensions": {
                        "trunkDepth": 303,
                        "trunkHeight": 189,
                        "trunkVolume": 11,
                        "trunkWidth": 176,
                        "vehicleHeight": 260,
                        "vehicleLength": 558,
                        "vehicleWidth": 240
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Renault",
                    "modelacriss": "",
                    "name": "Master",
                    "descr": "Hyvä valinta myös suurempiin ja vaativampiin kuljetustarpeisiin. \n\nVarusteina mm. vakionopeudensäädin, peruutustutka ja -kamera, navigaattori, mäkilähtöavustin ja Extended grip –järjestelmä, AUX- ja USB-liitännät, Bluetooth, älypuhelinpeilaus Android Auto + Apple CarPlay",
                    "descren": "Renault Master is good option for a bigger transportation needs. \n",
                    "notes": "- Sininen merkkivalo kertoo kylmästä moottorista. Valo sammuu kun moottori lämpenee. Autoa voi käyttää normaalisti.\n\n- Vältä käsijarrun käyttöä talviaikaan, etenkin varauksesi päätteeksi. Auton voi tasaisella jättää 1-vaihteelle ilman käsijarrua.\n\n- Renault-merkkisten autojen polttoainemittari näyttää usein täytenäkin vajaata. Tankkaa auto varauksesi päättyessä AINA täyteen ja säilytä kuitti. Jos epäilet tankanneesi enemmän kuin kulutit, täytä reklamaatio osoitteessa https://www.24rent.fi/polttoainereklamaatio.",
                    "notesen": "- Blue warning light means that engine is cold. Light turns off when engine heats up. You can use the van normally.\n\n- The fuel gauge in many Renault models may show inaccurate readings even when the tank is full. ALWAYS fill up the tank before you return the vehicle and keep the receipt. If you feel you needed to fill up more than you used, please submit a fuel complaint at https://www.24rent.fi/polttoainereklamaatio.\n\n- Renault Master may sometimes display the following warning lights: Injection fault or Check emissions/engine. These are due to incorrect sensor readings. If no other warnings are shown, you can drive the van as usual.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "745_63_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "745_63_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "745_63_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "745_63_4_large.webp"
                    }
                ]
            },
            {
                "id": "910",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 6028.383550584907,
                "homeLocationData": {
                    "id": 4770,
                    "address": "Tapionaukio - Aimo Park",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.17671,
                        "longitude": 24.807301
                    },
                    "descriptions": {
                        "en": "Aimo Park Tapiola Park outside parking area.\r\nDo not go down into the parking garage.",
                        "fi": "Tapiola Park ulkoparkkialue (Aimo Park).\r\nKauppakeskuksesta ulos ja parkkialue näkyy otaniemen puolella.\r\nAutolla tultaessa kierrä liikenneympyrän ulkoreunaa, ÄLÄ aja alas halliin."
                    },
                    "fullAddress": "Tapionaukio - Aimo Park, 02100 Espoo",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Tapiola",
                    "postalCode": "02100",
                    "notes": "https://www.24rent.fi/kulkuohje-aimo-parkeihin/",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2500,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [
                            "tuntiveloitus laskee pidemmissä vuokrauksissa"
                        ],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 35000,
                        "towHitch": 900,
                        "unlimitedKilometers": 1000,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 33000,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "automaattivaihteinen"
                ],
                "vehicleData": {
                    "id": 910,
                    "acriss": "",
                    "airbagCount": 1,
                    "brakedTowingCapacity": 2500,
                    "class": 1,
                    "co2Emissions": 194,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 29,
                    "currentMileage": 53493,
                    "currentVoltage": 12.28,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 112,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": true,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Tapionaukio, 02100 Espoo",
                    "hybridity": "none",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1274,
                    "modelYear": 2020,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "ZNK-316",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 55,
                        "dimensions": {
                            "trunkDepth": 430,
                            "trunkHeight": 196,
                            "trunkVolume": 14,
                            "trunkWidth": 181,
                            "vehicleHeight": 280,
                            "vehicleLength": 685,
                            "vehicleWidth": 210
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "VW",
                        "modelacriss": "",
                        "name": "Crafter",
                        "descr": "VW Crafter on erittäin mukava ja laadukas pakettiauto myös vaativampiin kuljetustarpeisiin. \n\nVarustettu pysäköintitutkilla ja peruutuskameralla. Automaattinen lisälämmitin auttaa talvella!",
                        "descren": "VW Crafter is very comfortable and high quality option for bigger transportation needs.\n\nEquipped with rear view camera and parking sensors.\n",
                        "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU PARKKIHALLEIHIN! \n\n- Auton PITUUS n. 7 m! Varo  liikennemerkkejä ja räystäitä kääntyessäsi!\n\n- Automaattivaihteisto, Käynnistä jarrupoljin painettuna.\n\n- Mikäli joku ovista on raollaan, ei keskuslukitus sulje ovia.\n\n- Jos ovet naksahtavat takaisin kiinni heti puhelimella avaamisen jälkeen, yritä uudelleen ja vedä kahvasti heti naksahduksen kuultuasi.",
                        "notesen": "- Height ~2.8 m: DOES NOT FIT INTO MOST PARKING GARAGES!\n\n- Van is also almost 7 METERS LONG! Drive carefully while turning!\n\n- The doors are quite stiff to use. Please ensure that all doors are properly closed before locking them.\n\n- Automatic transmission\n\n- If the locks close right away when opened via portal, try again and immediately pull the handle when you hear the click. ",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 55,
                    "dimensions": {
                        "trunkDepth": 430,
                        "trunkHeight": 196,
                        "trunkVolume": 14,
                        "trunkWidth": 181,
                        "vehicleHeight": 280,
                        "vehicleLength": 685,
                        "vehicleWidth": 210
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "VW",
                    "modelacriss": "",
                    "name": "Crafter",
                    "descr": "VW Crafter on erittäin mukava ja laadukas pakettiauto myös vaativampiin kuljetustarpeisiin. \n\nVarustettu pysäköintitutkilla ja peruutuskameralla. Automaattinen lisälämmitin auttaa talvella!",
                    "descren": "VW Crafter is very comfortable and high quality option for bigger transportation needs.\n\nEquipped with rear view camera and parking sensors.\n",
                    "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU PARKKIHALLEIHIN! \n\n- Auton PITUUS n. 7 m! Varo  liikennemerkkejä ja räystäitä kääntyessäsi!\n\n- Automaattivaihteisto, Käynnistä jarrupoljin painettuna.\n\n- Mikäli joku ovista on raollaan, ei keskuslukitus sulje ovia.\n\n- Jos ovet naksahtavat takaisin kiinni heti puhelimella avaamisen jälkeen, yritä uudelleen ja vedä kahvasti heti naksahduksen kuultuasi.",
                    "notesen": "- Height ~2.8 m: DOES NOT FIT INTO MOST PARKING GARAGES!\n\n- Van is also almost 7 METERS LONG! Drive carefully while turning!\n\n- The doors are quite stiff to use. Please ensure that all doors are properly closed before locking them.\n\n- Automatic transmission\n\n- If the locks close right away when opened via portal, try again and immediately pull the handle when you hear the click. ",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "565_55_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "565_55_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "565_55_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "565_55_4_large.webp"
                    }
                ]
            },
            {
                "id": "929",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 6028.383550584907,
                "homeLocationData": {
                    "id": 4770,
                    "address": "Tapionaukio - Aimo Park",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.17671,
                        "longitude": 24.807301
                    },
                    "descriptions": {
                        "en": "Aimo Park Tapiola Park outside parking area.\r\nDo not go down into the parking garage.",
                        "fi": "Tapiola Park ulkoparkkialue (Aimo Park).\r\nKauppakeskuksesta ulos ja parkkialue näkyy otaniemen puolella.\r\nAutolla tultaessa kierrä liikenneympyrän ulkoreunaa, ÄLÄ aja alas halliin."
                    },
                    "fullAddress": "Tapionaukio - Aimo Park, 02100 Espoo",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Tapiola",
                    "postalCode": "02100",
                    "notes": "https://www.24rent.fi/kulkuohje-aimo-parkeihin/",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2500,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 31800,
                        "towHitch": 900,
                        "unlimitedKilometers": 1000,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 29800,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "automaattivaihteinen"
                ],
                "vehicleData": {
                    "id": 929,
                    "acriss": "",
                    "airbagCount": 1,
                    "brakedTowingCapacity": 2500,
                    "class": 1,
                    "co2Emissions": 194,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 32,
                    "currentMileage": 55555,
                    "currentVoltage": 11.96,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 112,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": true,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Tapionaukio, 02100 Espoo",
                    "hybridity": "none",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1274,
                    "modelYear": 2020,
                    "notesInEnglish": "",
                    "notesInFinnish": "Automaattivaihteisto",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "ZNK-315",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 55,
                        "dimensions": {
                            "trunkDepth": 430,
                            "trunkHeight": 196,
                            "trunkVolume": 14,
                            "trunkWidth": 181,
                            "vehicleHeight": 280,
                            "vehicleLength": 685,
                            "vehicleWidth": 210
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "VW",
                        "modelacriss": "",
                        "name": "Crafter",
                        "descr": "VW Crafter on erittäin mukava ja laadukas pakettiauto myös vaativampiin kuljetustarpeisiin. \n\nVarustettu pysäköintitutkilla ja peruutuskameralla. Automaattinen lisälämmitin auttaa talvella!",
                        "descren": "VW Crafter is very comfortable and high quality option for bigger transportation needs.\n\nEquipped with rear view camera and parking sensors.\n",
                        "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU PARKKIHALLEIHIN! \n\n- Auton PITUUS n. 7 m! Varo  liikennemerkkejä ja räystäitä kääntyessäsi!\n\n- Automaattivaihteisto, Käynnistä jarrupoljin painettuna.\n\n- Mikäli joku ovista on raollaan, ei keskuslukitus sulje ovia.\n\n- Jos ovet naksahtavat takaisin kiinni heti puhelimella avaamisen jälkeen, yritä uudelleen ja vedä kahvasti heti naksahduksen kuultuasi.",
                        "notesen": "- Height ~2.8 m: DOES NOT FIT INTO MOST PARKING GARAGES!\n\n- Van is also almost 7 METERS LONG! Drive carefully while turning!\n\n- The doors are quite stiff to use. Please ensure that all doors are properly closed before locking them.\n\n- Automatic transmission\n\n- If the locks close right away when opened via portal, try again and immediately pull the handle when you hear the click. ",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 55,
                    "dimensions": {
                        "trunkDepth": 430,
                        "trunkHeight": 196,
                        "trunkVolume": 14,
                        "trunkWidth": 181,
                        "vehicleHeight": 280,
                        "vehicleLength": 685,
                        "vehicleWidth": 210
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "VW",
                    "modelacriss": "",
                    "name": "Crafter",
                    "descr": "VW Crafter on erittäin mukava ja laadukas pakettiauto myös vaativampiin kuljetustarpeisiin. \n\nVarustettu pysäköintitutkilla ja peruutuskameralla. Automaattinen lisälämmitin auttaa talvella!",
                    "descren": "VW Crafter is very comfortable and high quality option for bigger transportation needs.\n\nEquipped with rear view camera and parking sensors.\n",
                    "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU PARKKIHALLEIHIN! \n\n- Auton PITUUS n. 7 m! Varo  liikennemerkkejä ja räystäitä kääntyessäsi!\n\n- Automaattivaihteisto, Käynnistä jarrupoljin painettuna.\n\n- Mikäli joku ovista on raollaan, ei keskuslukitus sulje ovia.\n\n- Jos ovet naksahtavat takaisin kiinni heti puhelimella avaamisen jälkeen, yritä uudelleen ja vedä kahvasti heti naksahduksen kuultuasi.",
                    "notesen": "- Height ~2.8 m: DOES NOT FIT INTO MOST PARKING GARAGES!\n\n- Van is also almost 7 METERS LONG! Drive carefully while turning!\n\n- The doors are quite stiff to use. Please ensure that all doors are properly closed before locking them.\n\n- Automatic transmission\n\n- If the locks close right away when opened via portal, try again and immediately pull the handle when you hear the click. ",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "565_55_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "565_55_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "565_55_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "565_55_4_large.webp"
                    }
                ]
            },
            {
                "id": "1465",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 6028.383550584907,
                "homeLocationData": {
                    "id": 4770,
                    "address": "Tapionaukio - Aimo Park",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.17671,
                        "longitude": 24.807301
                    },
                    "descriptions": {
                        "en": "Aimo Park Tapiola Park outside parking area.\r\nDo not go down into the parking garage.",
                        "fi": "Tapiola Park ulkoparkkialue (Aimo Park).\r\nKauppakeskuksesta ulos ja parkkialue näkyy otaniemen puolella.\r\nAutolla tultaessa kierrä liikenneympyrän ulkoreunaa, ÄLÄ aja alas halliin."
                    },
                    "fullAddress": "Tapionaukio - Aimo Park, 02100 Espoo",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Tapiola",
                    "postalCode": "02100",
                    "notes": "https://www.24rent.fi/kulkuohje-aimo-parkeihin/",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2500,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 27500,
                        "towHitch": 900,
                        "unlimitedKilometers": 1500,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 25500,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 1465,
                    "acriss": "",
                    "airbagCount": 5,
                    "brakedTowingCapacity": 2500,
                    "class": 2,
                    "co2Emissions": 218,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 28,
                    "currentMileage": 4546,
                    "currentVoltage": 12.52,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 96,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Tapionaukio, 02100 Espoo",
                    "hybridity": "normal",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1293,
                    "modelYear": 2022,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "YLM-827",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 76,
                        "dimensions": {
                            "trunkDepth": 353,
                            "trunkHeight": 188,
                            "trunkVolume": 11,
                            "trunkWidth": 178,
                            "vehicleHeight": 260,
                            "vehicleLength": 598,
                            "vehicleWidth": 250
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Ford",
                        "modelacriss": "",
                        "name": "Transit hybrid",
                        "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                        "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                        "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                        "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 76,
                    "dimensions": {
                        "trunkDepth": 353,
                        "trunkHeight": 188,
                        "trunkVolume": 11,
                        "trunkWidth": 178,
                        "vehicleHeight": 260,
                        "vehicleLength": 598,
                        "vehicleWidth": 250
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Ford",
                    "modelacriss": "",
                    "name": "Transit hybrid",
                    "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                    "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                    "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                    "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "1403_76_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "1403_76_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "1403_76_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "1403_76_4_large.webp"
                    }
                ]
            },
            {
                "id": "787",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 6093.435663148529,
                "homeLocationData": {
                    "id": 7013,
                    "address": "Martinkyläntie 57",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.274494,
                        "longitude": 24.813007
                    },
                    "descriptions": {
                        "en": "Parking lot of Pelican Self Storage. Use upper level parking places on the inner yard. Pelican staff does not participate in car rental.",
                        "fi": "Auto sijaitsee Pelican Self Storagen yläpihan parkkipaikalla. Pelicanin henkilökunta EI osallistu vuokraukseen. "
                    },
                    "fullAddress": "Martinkyläntie 57, 01720 Vantaa",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Varisto",
                    "postalCode": "01720",
                    "notes": "",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 3000,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 39400,
                        "towHitch": 1500,
                        "unlimitedKilometers": 4000,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 37400,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "automaattivaihteinen"
                ],
                "vehicleData": {
                    "id": 787,
                    "acriss": "",
                    "airbagCount": 1,
                    "brakedTowingCapacity": 2500,
                    "class": 1,
                    "co2Emissions": 269,
                    "consumptionInCity": 13,
                    "consumptionOnRoad": 10,
                    "combinedConsumption": 11.5,
                    "currentDistanceToHome": 126,
                    "currentMileage": 72564,
                    "currentVoltage": 12.17,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 4,
                    "engineDisplacement": 2,
                    "enginePower": 103,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": true,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Kiveliönpolku 1, 01720 Vantaa",
                    "hybridity": "none",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1056,
                    "modelYear": 2020,
                    "notesInEnglish": "",
                    "notesInFinnish": "Automaattivaihteisto, pituus 7.4 m",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "ZNK-313",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "kitka",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 62,
                        "dimensions": {
                            "trunkDepth": 485,
                            "trunkHeight": 196,
                            "trunkVolume": 16,
                            "trunkWidth": 181,
                            "vehicleHeight": 300,
                            "vehicleLength": 740,
                            "vehicleWidth": 210
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "VW",
                        "modelacriss": "",
                        "name": "Crafter aut",
                        "descr": "VW Crafter on erittäin mukava ja laadukas pakettiauto myös vaativimpiin kuljetustarpeisiin. Mallistomme suurin pakettiauto! \n\nVarustettu pysäköintitutkilla ja peruutuskameralla. ",
                        "descren": "VW Crafter is very comfortable and high quality option for bigger transportation needs.\n\nEquipped with rear view camera and parking sensors.\n",
                        "notes": "- Huomioi ajoneuvon n. 2,8 m korkeus: AUTO EI MAHDU PARKKIHALLEIHIN! \n\n- Auton PITUUS yli 7.4m! Varo  liikennemerkkejä ja räystäitä kääntyessäsi!\n\n- Mikäli joku ovista on raollaan, ei keskuslukitus sulje ovia.\n\n- Jos ovet naksahtavat takaisin kiinni heti puhelimella avaamisen jälkeen, yritä uudelleen ja vedä kahvasti heti naksahduksen kuultuasi.",
                        "notesen": "- DOES NOT FIT INTO MOST PARKING GARAGES!\n\n- Van is also more than 7m LONG! Drive carefully while turning!\n\n- The doors are quite stiff to use. Please ensure that all doors are properly closed before locking them.\n\n- If the locks close right away when opened via portal, try again and immediately pull the handle when you hear the click. ",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 62,
                    "dimensions": {
                        "trunkDepth": 485,
                        "trunkHeight": 196,
                        "trunkVolume": 16,
                        "trunkWidth": 181,
                        "vehicleHeight": 300,
                        "vehicleLength": 740,
                        "vehicleWidth": 210
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "VW",
                    "modelacriss": "",
                    "name": "Crafter aut",
                    "descr": "VW Crafter on erittäin mukava ja laadukas pakettiauto myös vaativimpiin kuljetustarpeisiin. Mallistomme suurin pakettiauto! \n\nVarustettu pysäköintitutkilla ja peruutuskameralla. ",
                    "descren": "VW Crafter is very comfortable and high quality option for bigger transportation needs.\n\nEquipped with rear view camera and parking sensors.\n",
                    "notes": "- Huomioi ajoneuvon n. 2,8 m korkeus: AUTO EI MAHDU PARKKIHALLEIHIN! \n\n- Auton PITUUS yli 7.4m! Varo  liikennemerkkejä ja räystäitä kääntyessäsi!\n\n- Mikäli joku ovista on raollaan, ei keskuslukitus sulje ovia.\n\n- Jos ovet naksahtavat takaisin kiinni heti puhelimella avaamisen jälkeen, yritä uudelleen ja vedä kahvasti heti naksahduksen kuultuasi.",
                    "notesen": "- DOES NOT FIT INTO MOST PARKING GARAGES!\n\n- Van is also more than 7m LONG! Drive carefully while turning!\n\n- The doors are quite stiff to use. Please ensure that all doors are properly closed before locking them.\n\n- If the locks close right away when opened via portal, try again and immediately pull the handle when you hear the click. ",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": []
            },
            {
                "id": "831",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 6093.435663148529,
                "homeLocationData": {
                    "id": 7013,
                    "address": "Martinkyläntie 57",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.274494,
                        "longitude": 24.813007
                    },
                    "descriptions": {
                        "en": "Parking lot of Pelican Self Storage. Use upper level parking places on the inner yard. Pelican staff does not participate in car rental.",
                        "fi": "Auto sijaitsee Pelican Self Storagen yläpihan parkkipaikalla. Pelicanin henkilökunta EI osallistu vuokraukseen. "
                    },
                    "fullAddress": "Martinkyläntie 57, 01720 Vantaa",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Varisto",
                    "postalCode": "01720",
                    "notes": "",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2000,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 26500,
                        "towHitch": 900,
                        "unlimitedKilometers": 2000,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 24500,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "automaattivaihteinen"
                ],
                "vehicleData": {
                    "id": 831,
                    "acriss": "",
                    "airbagCount": 1,
                    "brakedTowingCapacity": 2500,
                    "class": 1,
                    "co2Emissions": 194,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 114,
                    "currentMileage": 63973,
                    "currentVoltage": 11.96,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 103,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": true,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Martinkyläntie 58, 01720 Vantaa",
                    "hybridity": "none",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1274,
                    "modelYear": 2020,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "YKJ-854",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 50,
                        "dimensions": {
                            "trunkDepth": 345,
                            "trunkHeight": 196,
                            "trunkVolume": 11,
                            "trunkWidth": 181,
                            "vehicleHeight": 270,
                            "vehicleLength": 600,
                            "vehicleWidth": 210
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "VW",
                        "modelacriss": "",
                        "name": "Crafter aut",
                        "descr": "VW Crafter on erittäin mukava ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. \n\nVarustettu pysäköintitutkilla ja peruutuskameralla. ",
                        "descren": "VW Crafter is very comfortable and high quality option for bigger transportation needs.\n\nEquipped with rear view camera and parking sensors.\n",
                        "notes": "- Huomioi ajoneuvon korkeus vajaa 3m: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Automaattivaihteisto. Käynnistä jarrupoljin painettuna.\n\n- Mikäli joku ovista on raollaan, ei keskuslukitus lukitse ovia.\n\n- Jos ovet naksahtavat takaisin kiinni heti puhelimella avaamisen jälkeen, yritä uudelleen ja vedä kahvasti heti naksahduksen kuultuasi.",
                        "notesen": "- Almost 3 meters tall! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Automatic transmission. Press brake pedal while starting.\n\n- The doors are quite stiff to use. Please ensure that all doors are properly closed before locking them.\n\n- If the locks close right away when opened via portal, try again and immediately pull the handle when you hear the click. ",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 50,
                    "dimensions": {
                        "trunkDepth": 345,
                        "trunkHeight": 196,
                        "trunkVolume": 11,
                        "trunkWidth": 181,
                        "vehicleHeight": 270,
                        "vehicleLength": 600,
                        "vehicleWidth": 210
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "VW",
                    "modelacriss": "",
                    "name": "Crafter aut",
                    "descr": "VW Crafter on erittäin mukava ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. \n\nVarustettu pysäköintitutkilla ja peruutuskameralla. ",
                    "descren": "VW Crafter is very comfortable and high quality option for bigger transportation needs.\n\nEquipped with rear view camera and parking sensors.\n",
                    "notes": "- Huomioi ajoneuvon korkeus vajaa 3m: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Automaattivaihteisto. Käynnistä jarrupoljin painettuna.\n\n- Mikäli joku ovista on raollaan, ei keskuslukitus lukitse ovia.\n\n- Jos ovet naksahtavat takaisin kiinni heti puhelimella avaamisen jälkeen, yritä uudelleen ja vedä kahvasti heti naksahduksen kuultuasi.",
                    "notesen": "- Almost 3 meters tall! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Automatic transmission. Press brake pedal while starting.\n\n- The doors are quite stiff to use. Please ensure that all doors are properly closed before locking them.\n\n- If the locks close right away when opened via portal, try again and immediately pull the handle when you hear the click. ",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "525_50_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "525_50_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "525_50_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "525_50_4_large.webp"
                    }
                ]
            },
            {
                "id": "788",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 6115.5189900458545,
                "homeLocationData": {
                    "id": 6091,
                    "address": "Nilsiänkatu  5",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.195288,
                        "longitude": 24.951819
                    },
                    "descriptions": {
                        "en": "Big parking area operated by Aimo Park.",
                        "fi": "Iso Aimo Parkin hallinnoima pysäköintialue."
                    },
                    "fullAddress": "Nilsiänkatu  5, 00510 Helsinki",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Vallila P-alue",
                    "postalCode": "00510",
                    "notes": "Autot ovat sisäänkäynnin lähettyvillä tai keskemmällä pihaa. Perällä on työmaa-aluetta, johon ei saa pysäköidä",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 3000,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 39800,
                        "towHitch": 1500,
                        "unlimitedKilometers": 3000,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 37800,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "automaattivaihteinen"
                ],
                "vehicleData": {
                    "id": 788,
                    "acriss": "",
                    "airbagCount": 1,
                    "brakedTowingCapacity": 2500,
                    "class": 1,
                    "co2Emissions": 269,
                    "consumptionInCity": 13,
                    "consumptionOnRoad": 10,
                    "combinedConsumption": 11.5,
                    "currentDistanceToHome": 34,
                    "currentMileage": 63004,
                    "currentVoltage": 12.17,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 4,
                    "engineDisplacement": 2,
                    "enginePower": 103,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": true,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Nilsiänkatu 7, 00510 Helsinki",
                    "hybridity": "none",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1056,
                    "modelYear": 2020,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "ZNK-314",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "kitka",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 62,
                        "dimensions": {
                            "trunkDepth": 485,
                            "trunkHeight": 196,
                            "trunkVolume": 16,
                            "trunkWidth": 181,
                            "vehicleHeight": 300,
                            "vehicleLength": 740,
                            "vehicleWidth": 210
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "VW",
                        "modelacriss": "",
                        "name": "Crafter aut",
                        "descr": "VW Crafter on erittäin mukava ja laadukas pakettiauto myös vaativimpiin kuljetustarpeisiin. Mallistomme suurin pakettiauto! \n\nVarustettu pysäköintitutkilla ja peruutuskameralla. ",
                        "descren": "VW Crafter is very comfortable and high quality option for bigger transportation needs.\n\nEquipped with rear view camera and parking sensors.\n",
                        "notes": "- Huomioi ajoneuvon n. 2,8 m korkeus: AUTO EI MAHDU PARKKIHALLEIHIN! \n\n- Auton PITUUS yli 7.4m! Varo  liikennemerkkejä ja räystäitä kääntyessäsi!\n\n- Mikäli joku ovista on raollaan, ei keskuslukitus sulje ovia.\n\n- Jos ovet naksahtavat takaisin kiinni heti puhelimella avaamisen jälkeen, yritä uudelleen ja vedä kahvasti heti naksahduksen kuultuasi.",
                        "notesen": "- DOES NOT FIT INTO MOST PARKING GARAGES!\n\n- Van is also more than 7m LONG! Drive carefully while turning!\n\n- The doors are quite stiff to use. Please ensure that all doors are properly closed before locking them.\n\n- If the locks close right away when opened via portal, try again and immediately pull the handle when you hear the click. ",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 62,
                    "dimensions": {
                        "trunkDepth": 485,
                        "trunkHeight": 196,
                        "trunkVolume": 16,
                        "trunkWidth": 181,
                        "vehicleHeight": 300,
                        "vehicleLength": 740,
                        "vehicleWidth": 210
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "VW",
                    "modelacriss": "",
                    "name": "Crafter aut",
                    "descr": "VW Crafter on erittäin mukava ja laadukas pakettiauto myös vaativimpiin kuljetustarpeisiin. Mallistomme suurin pakettiauto! \n\nVarustettu pysäköintitutkilla ja peruutuskameralla. ",
                    "descren": "VW Crafter is very comfortable and high quality option for bigger transportation needs.\n\nEquipped with rear view camera and parking sensors.\n",
                    "notes": "- Huomioi ajoneuvon n. 2,8 m korkeus: AUTO EI MAHDU PARKKIHALLEIHIN! \n\n- Auton PITUUS yli 7.4m! Varo  liikennemerkkejä ja räystäitä kääntyessäsi!\n\n- Mikäli joku ovista on raollaan, ei keskuslukitus sulje ovia.\n\n- Jos ovet naksahtavat takaisin kiinni heti puhelimella avaamisen jälkeen, yritä uudelleen ja vedä kahvasti heti naksahduksen kuultuasi.",
                    "notesen": "- DOES NOT FIT INTO MOST PARKING GARAGES!\n\n- Van is also more than 7m LONG! Drive carefully while turning!\n\n- The doors are quite stiff to use. Please ensure that all doors are properly closed before locking them.\n\n- If the locks close right away when opened via portal, try again and immediately pull the handle when you hear the click. ",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": []
            },
            {
                "id": "855",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 6115.5189900458545,
                "homeLocationData": {
                    "id": 6091,
                    "address": "Nilsiänkatu  5",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.195288,
                        "longitude": 24.951819
                    },
                    "descriptions": {
                        "en": "Big parking area operated by Aimo Park.",
                        "fi": "Iso Aimo Parkin hallinnoima pysäköintialue."
                    },
                    "fullAddress": "Nilsiänkatu  5, 00510 Helsinki",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Vallila P-alue",
                    "postalCode": "00510",
                    "notes": "Autot ovat sisäänkäynnin lähettyvillä tai keskemmällä pihaa. Perällä on työmaa-aluetta, johon ei saa pysäköidä",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2000,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [
                            "tuntiveloitus laskee pidemmissä vuokrauksissa"
                        ],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 31000,
                        "towHitch": 900,
                        "unlimitedKilometers": 1500,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 29000,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 855,
                    "acriss": "",
                    "airbagCount": 1,
                    "brakedTowingCapacity": 2500,
                    "class": 1,
                    "co2Emissions": 249,
                    "consumptionInCity": 12,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10.5,
                    "currentDistanceToHome": 40,
                    "currentMileage": 36613,
                    "currentVoltage": 11.92,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2.3,
                    "enginePower": 110,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 6,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Nilsiänkatu 7, 00510 Helsinki",
                    "hybridity": "none",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1434,
                    "modelYear": 2020,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "YXE-618",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 60,
                        "dimensions": {
                            "trunkDepth": 373,
                            "trunkHeight": 189,
                            "trunkVolume": 13,
                            "trunkWidth": 176,
                            "vehicleHeight": 260,
                            "vehicleLength": 620,
                            "vehicleWidth": 210
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Renault",
                        "modelacriss": "",
                        "name": "Master",
                        "descr": "Renault Master on hyvä valinta myös suuriin ja vaativiin kuljetustarpeisiin.\n\n",
                        "descren": "Renault Master is a reliable and handy van. ",
                        "notes": "- Auton korkeus on 2,5 m. SE EI MAHDU USEIMPIIN PARKKIHALLEIHIN!\n\n- Autossa on peruutuskamera, ei taustapeiliä.\n\n- Vältä käsijarrun käyttöä talviaikaan, etenkin varauksesi päätteeksi. Auton voi tasaisella jättää 1-vaihteelle ilman käsijarrua.\n \n- Renault-merkkisten autojen polttoainemittari näyttää usein täytenäkin vajaata. Tankkaa auto varauksesi päättyessä AINA täyteen ja säilytä kuitti. Jos epäilet tankanneesi enemmän kuin kulutit, täytä reklamaatio osoitteessa https://www.24rent.fi/polttoainereklamaatio.\n\n- Renault Master saattaa joskus näyttää seuraavat varoitukset: Injection fault tai Check emissions/engine. Ne johtuvat ajoittain ilmenevistä virheellisistä anturiarvoista. Mikäli muita varoituksia ei ilmaannu, autolla voi ajaa normaalisti.",
                        "notesen": "- The van is 2.5m high. DOES NOT FIT FOR INDOOR PARKING HALLS!\n- The van has a backup camera. It does not have a rear-view mirror nor cargo windows.\n- The fuel gauge may show inaccurate readings even when the tank is full. This is a known issue with this model and, unfortunately, something we cannot fix. If you are planning on making a complaint about the fuel level, refill the tank immediately after the pick up and keep the receipt.\n- Renault Master may sometimes display the following warning lights: Injection fault or Check emissions/engine. These are due to incorrect sensor readings. If no other warnings are shown, you can drive the van as usual.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 60,
                    "dimensions": {
                        "trunkDepth": 373,
                        "trunkHeight": 189,
                        "trunkVolume": 13,
                        "trunkWidth": 176,
                        "vehicleHeight": 260,
                        "vehicleLength": 620,
                        "vehicleWidth": 210
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Renault",
                    "modelacriss": "",
                    "name": "Master",
                    "descr": "Renault Master on hyvä valinta myös suuriin ja vaativiin kuljetustarpeisiin.\n\n",
                    "descren": "Renault Master is a reliable and handy van. ",
                    "notes": "- Auton korkeus on 2,5 m. SE EI MAHDU USEIMPIIN PARKKIHALLEIHIN!\n\n- Autossa on peruutuskamera, ei taustapeiliä.\n\n- Vältä käsijarrun käyttöä talviaikaan, etenkin varauksesi päätteeksi. Auton voi tasaisella jättää 1-vaihteelle ilman käsijarrua.\n \n- Renault-merkkisten autojen polttoainemittari näyttää usein täytenäkin vajaata. Tankkaa auto varauksesi päättyessä AINA täyteen ja säilytä kuitti. Jos epäilet tankanneesi enemmän kuin kulutit, täytä reklamaatio osoitteessa https://www.24rent.fi/polttoainereklamaatio.\n\n- Renault Master saattaa joskus näyttää seuraavat varoitukset: Injection fault tai Check emissions/engine. Ne johtuvat ajoittain ilmenevistä virheellisistä anturiarvoista. Mikäli muita varoituksia ei ilmaannu, autolla voi ajaa normaalisti.",
                    "notesen": "- The van is 2.5m high. DOES NOT FIT FOR INDOOR PARKING HALLS!\n- The van has a backup camera. It does not have a rear-view mirror nor cargo windows.\n- The fuel gauge may show inaccurate readings even when the tank is full. This is a known issue with this model and, unfortunately, something we cannot fix. If you are planning on making a complaint about the fuel level, refill the tank immediately after the pick up and keep the receipt.\n- Renault Master may sometimes display the following warning lights: Injection fault or Check emissions/engine. These are due to incorrect sensor readings. If no other warnings are shown, you can drive the van as usual.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "748_60_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "748_60_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "748_60_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "748_60_4_large.webp"
                    }
                ]
            },
            {
                "id": "1633",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 6162.066401239108,
                "homeLocationData": {
                    "id": 5505,
                    "address": "Yhdyskunnantie 53-55",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.250759,
                        "longitude": 24.95651
                    },
                    "descriptions": {
                        "en": "Free parking on the side of the street.",
                        "fi": "Rajoittamatonta kadunvarsipysäköintiä"
                    },
                    "fullAddress": "Yhdyskunnantie 53-55, 00680 Helsinki",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Pakila",
                    "postalCode": "00680",
                    "notes": "",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2500,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 26700,
                        "towHitch": 900,
                        "unlimitedKilometers": 1500,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 24700,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 1633,
                    "acriss": "",
                    "airbagCount": 5,
                    "brakedTowingCapacity": 2500,
                    "class": 2,
                    "co2Emissions": 218,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 39,
                    "currentMileage": 7918,
                    "currentVoltage": 12.67,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 96,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Yhdyskunnantie 53, 00680 Helsinki",
                    "hybridity": "normal",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1293,
                    "modelYear": 2022,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "YLM-845",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 76,
                        "dimensions": {
                            "trunkDepth": 353,
                            "trunkHeight": 188,
                            "trunkVolume": 11,
                            "trunkWidth": 178,
                            "vehicleHeight": 260,
                            "vehicleLength": 598,
                            "vehicleWidth": 250
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Ford",
                        "modelacriss": "",
                        "name": "Transit hybrid",
                        "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                        "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                        "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                        "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 76,
                    "dimensions": {
                        "trunkDepth": 353,
                        "trunkHeight": 188,
                        "trunkVolume": 11,
                        "trunkWidth": 178,
                        "vehicleHeight": 260,
                        "vehicleLength": 598,
                        "vehicleWidth": 250
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Ford",
                    "modelacriss": "",
                    "name": "Transit hybrid",
                    "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                    "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                    "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                    "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "1403_76_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "1403_76_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "1403_76_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "1403_76_4_large.webp"
                    }
                ]
            },
            {
                "id": "1207",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 6354.0832360538025,
                "homeLocationData": {
                    "id": 34,
                    "address": "Keilalahdentie 5",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.169786,
                        "longitude": 24.826064
                    },
                    "descriptions": {
                        "en": "Along Keilalahdentie, 24h angled parking spaces on the west side",
                        "fi": "Keilalahdentien kadunvarressa, länsipuolinen P24-vinopysäköintialue."
                    },
                    "fullAddress": "Keilalahdentie 5, 02150 Espoo",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Keilalahti",
                    "postalCode": "02150",
                    "notes": "",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2000,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 25100,
                        "towHitch": 900,
                        "unlimitedKilometers": 1500,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 23100,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 1207,
                    "acriss": "",
                    "airbagCount": 1,
                    "brakedTowingCapacity": 2500,
                    "class": 1,
                    "co2Emissions": 247,
                    "consumptionInCity": 12,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 68,
                    "currentMileage": 32663,
                    "currentVoltage": 12.21,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2.3,
                    "enginePower": 110,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 6,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Keilalahdentie, 02150 Espoo",
                    "hybridity": "none",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1529,
                    "modelYear": 2021,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "JME-932",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 63,
                        "dimensions": {
                            "trunkDepth": 303,
                            "trunkHeight": 189,
                            "trunkVolume": 11,
                            "trunkWidth": 176,
                            "vehicleHeight": 260,
                            "vehicleLength": 558,
                            "vehicleWidth": 240
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Renault",
                        "modelacriss": "",
                        "name": "Master",
                        "descr": "Hyvä valinta myös suurempiin ja vaativampiin kuljetustarpeisiin. \n\nVarusteina mm. vakionopeudensäädin, peruutustutka ja -kamera, navigaattori, mäkilähtöavustin ja Extended grip –järjestelmä, AUX- ja USB-liitännät, Bluetooth, älypuhelinpeilaus Android Auto + Apple CarPlay",
                        "descren": "Renault Master is good option for a bigger transportation needs. \n",
                        "notes": "- Sininen merkkivalo kertoo kylmästä moottorista. Valo sammuu kun moottori lämpenee. Autoa voi käyttää normaalisti.\n\n- Vältä käsijarrun käyttöä talviaikaan, etenkin varauksesi päätteeksi. Auton voi tasaisella jättää 1-vaihteelle ilman käsijarrua.\n\n- Renault-merkkisten autojen polttoainemittari näyttää usein täytenäkin vajaata. Tankkaa auto varauksesi päättyessä AINA täyteen ja säilytä kuitti. Jos epäilet tankanneesi enemmän kuin kulutit, täytä reklamaatio osoitteessa https://www.24rent.fi/polttoainereklamaatio.",
                        "notesen": "- Blue warning light means that engine is cold. Light turns off when engine heats up. You can use the van normally.\n\n- The fuel gauge in many Renault models may show inaccurate readings even when the tank is full. ALWAYS fill up the tank before you return the vehicle and keep the receipt. If you feel you needed to fill up more than you used, please submit a fuel complaint at https://www.24rent.fi/polttoainereklamaatio.\n\n- Renault Master may sometimes display the following warning lights: Injection fault or Check emissions/engine. These are due to incorrect sensor readings. If no other warnings are shown, you can drive the van as usual.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 63,
                    "dimensions": {
                        "trunkDepth": 303,
                        "trunkHeight": 189,
                        "trunkVolume": 11,
                        "trunkWidth": 176,
                        "vehicleHeight": 260,
                        "vehicleLength": 558,
                        "vehicleWidth": 240
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Renault",
                    "modelacriss": "",
                    "name": "Master",
                    "descr": "Hyvä valinta myös suurempiin ja vaativampiin kuljetustarpeisiin. \n\nVarusteina mm. vakionopeudensäädin, peruutustutka ja -kamera, navigaattori, mäkilähtöavustin ja Extended grip –järjestelmä, AUX- ja USB-liitännät, Bluetooth, älypuhelinpeilaus Android Auto + Apple CarPlay",
                    "descren": "Renault Master is good option for a bigger transportation needs. \n",
                    "notes": "- Sininen merkkivalo kertoo kylmästä moottorista. Valo sammuu kun moottori lämpenee. Autoa voi käyttää normaalisti.\n\n- Vältä käsijarrun käyttöä talviaikaan, etenkin varauksesi päätteeksi. Auton voi tasaisella jättää 1-vaihteelle ilman käsijarrua.\n\n- Renault-merkkisten autojen polttoainemittari näyttää usein täytenäkin vajaata. Tankkaa auto varauksesi päättyessä AINA täyteen ja säilytä kuitti. Jos epäilet tankanneesi enemmän kuin kulutit, täytä reklamaatio osoitteessa https://www.24rent.fi/polttoainereklamaatio.",
                    "notesen": "- Blue warning light means that engine is cold. Light turns off when engine heats up. You can use the van normally.\n\n- The fuel gauge in many Renault models may show inaccurate readings even when the tank is full. ALWAYS fill up the tank before you return the vehicle and keep the receipt. If you feel you needed to fill up more than you used, please submit a fuel complaint at https://www.24rent.fi/polttoainereklamaatio.\n\n- Renault Master may sometimes display the following warning lights: Injection fault or Check emissions/engine. These are due to incorrect sensor readings. If no other warnings are shown, you can drive the van as usual.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "745_63_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "745_63_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "745_63_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "745_63_4_large.webp"
                    }
                ]
            },
            {
                "id": "1772",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 6354.0832360538025,
                "homeLocationData": {
                    "id": 34,
                    "address": "Keilalahdentie 5",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.169786,
                        "longitude": 24.826064
                    },
                    "descriptions": {
                        "en": "Along Keilalahdentie, 24h angled parking spaces on the west side",
                        "fi": "Keilalahdentien kadunvarressa, länsipuolinen P24-vinopysäköintialue."
                    },
                    "fullAddress": "Keilalahdentie 5, 02150 Espoo",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Keilalahti",
                    "postalCode": "02150",
                    "notes": "",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2500,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 26700,
                        "towHitch": 900,
                        "unlimitedKilometers": 1500,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 24700,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 1772,
                    "acriss": "",
                    "airbagCount": 5,
                    "brakedTowingCapacity": 2500,
                    "class": 2,
                    "co2Emissions": 218,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 53,
                    "currentMileage": 6601,
                    "currentVoltage": 12.73,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 96,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Keilalahdentie, 02150 Espoo",
                    "hybridity": "normal",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1293,
                    "modelYear": 2022,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "YLJ-182",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 76,
                        "dimensions": {
                            "trunkDepth": 353,
                            "trunkHeight": 188,
                            "trunkVolume": 11,
                            "trunkWidth": 178,
                            "vehicleHeight": 260,
                            "vehicleLength": 598,
                            "vehicleWidth": 250
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Ford",
                        "modelacriss": "",
                        "name": "Transit hybrid",
                        "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                        "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                        "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                        "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 76,
                    "dimensions": {
                        "trunkDepth": 353,
                        "trunkHeight": 188,
                        "trunkVolume": 11,
                        "trunkWidth": 178,
                        "vehicleHeight": 260,
                        "vehicleLength": 598,
                        "vehicleWidth": 250
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Ford",
                    "modelacriss": "",
                    "name": "Transit hybrid",
                    "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                    "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                    "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                    "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "1403_76_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "1403_76_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "1403_76_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "1403_76_4_large.webp"
                    }
                ]
            },
            {
                "id": "1224",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 6522.121515259546,
                "homeLocationData": {
                    "id": 4850,
                    "address": "Klinkkerikaari",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.279199,
                        "longitude": 24.815557
                    },
                    "descriptions": {
                        "en": "In the parking lot of Autoverkkokauppa. Use reserved parking space only!",
                        "fi": "Autoverkkokaupan pihassa lipputankojen vieressä. RTV:n puoleinen pääty. Käytä vain autolle varattua ruutua!"
                    },
                    "fullAddress": "Klinkkerikaari, 01720 Vantaa",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Petikko",
                    "postalCode": "01720",
                    "notes": "Autoverkkokaupan henkilökunta ei osallistu vuokraukseen!",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2000,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [
                            "tuntiveloitus laskee pidemmissä vuokrauksissa"
                        ],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 31200,
                        "towHitch": 900,
                        "unlimitedKilometers": 1500,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 29200,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 1224,
                    "acriss": "",
                    "airbagCount": 1,
                    "brakedTowingCapacity": 2500,
                    "class": 1,
                    "co2Emissions": 247,
                    "consumptionInCity": 12,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 8,
                    "currentMileage": 29652,
                    "currentVoltage": 12.28,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2.3,
                    "enginePower": 110,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 6,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Klinkkerikaari 4, 01720 Vantaa",
                    "hybridity": "none",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1529,
                    "modelYear": 2021,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "JME-929",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 63,
                        "dimensions": {
                            "trunkDepth": 303,
                            "trunkHeight": 189,
                            "trunkVolume": 11,
                            "trunkWidth": 176,
                            "vehicleHeight": 260,
                            "vehicleLength": 558,
                            "vehicleWidth": 240
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Renault",
                        "modelacriss": "",
                        "name": "Master",
                        "descr": "Hyvä valinta myös suurempiin ja vaativampiin kuljetustarpeisiin. \n\nVarusteina mm. vakionopeudensäädin, peruutustutka ja -kamera, navigaattori, mäkilähtöavustin ja Extended grip –järjestelmä, AUX- ja USB-liitännät, Bluetooth, älypuhelinpeilaus Android Auto + Apple CarPlay",
                        "descren": "Renault Master is good option for a bigger transportation needs. \n",
                        "notes": "- Sininen merkkivalo kertoo kylmästä moottorista. Valo sammuu kun moottori lämpenee. Autoa voi käyttää normaalisti.\n\n- Vältä käsijarrun käyttöä talviaikaan, etenkin varauksesi päätteeksi. Auton voi tasaisella jättää 1-vaihteelle ilman käsijarrua.\n\n- Renault-merkkisten autojen polttoainemittari näyttää usein täytenäkin vajaata. Tankkaa auto varauksesi päättyessä AINA täyteen ja säilytä kuitti. Jos epäilet tankanneesi enemmän kuin kulutit, täytä reklamaatio osoitteessa https://www.24rent.fi/polttoainereklamaatio.",
                        "notesen": "- Blue warning light means that engine is cold. Light turns off when engine heats up. You can use the van normally.\n\n- The fuel gauge in many Renault models may show inaccurate readings even when the tank is full. ALWAYS fill up the tank before you return the vehicle and keep the receipt. If you feel you needed to fill up more than you used, please submit a fuel complaint at https://www.24rent.fi/polttoainereklamaatio.\n\n- Renault Master may sometimes display the following warning lights: Injection fault or Check emissions/engine. These are due to incorrect sensor readings. If no other warnings are shown, you can drive the van as usual.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 63,
                    "dimensions": {
                        "trunkDepth": 303,
                        "trunkHeight": 189,
                        "trunkVolume": 11,
                        "trunkWidth": 176,
                        "vehicleHeight": 260,
                        "vehicleLength": 558,
                        "vehicleWidth": 240
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Renault",
                    "modelacriss": "",
                    "name": "Master",
                    "descr": "Hyvä valinta myös suurempiin ja vaativampiin kuljetustarpeisiin. \n\nVarusteina mm. vakionopeudensäädin, peruutustutka ja -kamera, navigaattori, mäkilähtöavustin ja Extended grip –järjestelmä, AUX- ja USB-liitännät, Bluetooth, älypuhelinpeilaus Android Auto + Apple CarPlay",
                    "descren": "Renault Master is good option for a bigger transportation needs. \n",
                    "notes": "- Sininen merkkivalo kertoo kylmästä moottorista. Valo sammuu kun moottori lämpenee. Autoa voi käyttää normaalisti.\n\n- Vältä käsijarrun käyttöä talviaikaan, etenkin varauksesi päätteeksi. Auton voi tasaisella jättää 1-vaihteelle ilman käsijarrua.\n\n- Renault-merkkisten autojen polttoainemittari näyttää usein täytenäkin vajaata. Tankkaa auto varauksesi päättyessä AINA täyteen ja säilytä kuitti. Jos epäilet tankanneesi enemmän kuin kulutit, täytä reklamaatio osoitteessa https://www.24rent.fi/polttoainereklamaatio.",
                    "notesen": "- Blue warning light means that engine is cold. Light turns off when engine heats up. You can use the van normally.\n\n- The fuel gauge in many Renault models may show inaccurate readings even when the tank is full. ALWAYS fill up the tank before you return the vehicle and keep the receipt. If you feel you needed to fill up more than you used, please submit a fuel complaint at https://www.24rent.fi/polttoainereklamaatio.\n\n- Renault Master may sometimes display the following warning lights: Injection fault or Check emissions/engine. These are due to incorrect sensor readings. If no other warnings are shown, you can drive the van as usual.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "745_63_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "745_63_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "745_63_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "745_63_4_large.webp"
                    }
                ]
            },
            {
                "id": "748",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 6993.059010650412,
                "homeLocationData": {
                    "id": 160,
                    "address": "Karamzininranta 2, Aimo Park Finlandia",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.174454,
                        "longitude": 24.934465
                    },
                    "descriptions": {
                        "en": "In Aimo Park Finlandia -garage. Parking level -2 near the exit. Do not use the last 10 parking spots before exit doors!\r\n\r\n(https://www.24rent.fi/kulkuohje-aimo-parkeihin/)  ",
                        "fi": "Aimo Park Finlandia -pysäköintitalossa. Auto on tasolla -2 ulosajon läheisyydessä. Älä kuitenkaan käytä ensimmäistä kymmentä ruutua uloskäynniltä katsottaessa sujuvan kulkemisen varmistamiseksi.\r\n\r\n(Kulkuohjeet: https://www.24rent.fi/kulkuohje-aimo-parkeihin/) "
                    },
                    "fullAddress": "Karamzininranta 2, Aimo Park Finlandia, 00100 Helsinki",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Aimo Park Finlandia",
                    "postalCode": "00100",
                    "notes": "Ei pysäköintiä ensimmäiseen 10 ruutuun puomilta alkaen!",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2000,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 30100,
                        "towHitch": 900,
                        "unlimitedKilometers": 2000,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 28100,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 748,
                    "acriss": "",
                    "airbagCount": 1,
                    "brakedTowingCapacity": 2500,
                    "class": 1,
                    "co2Emissions": 0,
                    "consumptionInCity": 10,
                    "consumptionOnRoad": 8,
                    "combinedConsumption": 10.5,
                    "currentDistanceToHome": 98,
                    "currentMileage": 67080,
                    "currentVoltage": 12.14,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2.2,
                    "enginePower": 81,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 6,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Mannerheimintie, 00100 Helsinki",
                    "hybridity": "none",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1684,
                    "modelYear": 2020,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "YKN-779",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "kitka",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 60,
                        "dimensions": {
                            "trunkDepth": 373,
                            "trunkHeight": 189,
                            "trunkVolume": 13,
                            "trunkWidth": 176,
                            "vehicleHeight": 260,
                            "vehicleLength": 620,
                            "vehicleWidth": 210
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Renault",
                        "modelacriss": "",
                        "name": "Master",
                        "descr": "Renault Master on hyvä valinta myös suuriin ja vaativiin kuljetustarpeisiin.\n\n",
                        "descren": "Renault Master is a reliable and handy van. ",
                        "notes": "- Auton korkeus on 2,5 m. SE EI MAHDU USEIMPIIN PARKKIHALLEIHIN!\n\n- Autossa on peruutuskamera, ei taustapeiliä.\n\n- Vältä käsijarrun käyttöä talviaikaan, etenkin varauksesi päätteeksi. Auton voi tasaisella jättää 1-vaihteelle ilman käsijarrua.\n \n- Renault-merkkisten autojen polttoainemittari näyttää usein täytenäkin vajaata. Tankkaa auto varauksesi päättyessä AINA täyteen ja säilytä kuitti. Jos epäilet tankanneesi enemmän kuin kulutit, täytä reklamaatio osoitteessa https://www.24rent.fi/polttoainereklamaatio.\n\n- Renault Master saattaa joskus näyttää seuraavat varoitukset: Injection fault tai Check emissions/engine. Ne johtuvat ajoittain ilmenevistä virheellisistä anturiarvoista. Mikäli muita varoituksia ei ilmaannu, autolla voi ajaa normaalisti.",
                        "notesen": "- The van is 2.5m high. DOES NOT FIT FOR INDOOR PARKING HALLS!\n- The van has a backup camera. It does not have a rear-view mirror nor cargo windows.\n- The fuel gauge may show inaccurate readings even when the tank is full. This is a known issue with this model and, unfortunately, something we cannot fix. If you are planning on making a complaint about the fuel level, refill the tank immediately after the pick up and keep the receipt.\n- Renault Master may sometimes display the following warning lights: Injection fault or Check emissions/engine. These are due to incorrect sensor readings. If no other warnings are shown, you can drive the van as usual.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 60,
                    "dimensions": {
                        "trunkDepth": 373,
                        "trunkHeight": 189,
                        "trunkVolume": 13,
                        "trunkWidth": 176,
                        "vehicleHeight": 260,
                        "vehicleLength": 620,
                        "vehicleWidth": 210
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Renault",
                    "modelacriss": "",
                    "name": "Master",
                    "descr": "Renault Master on hyvä valinta myös suuriin ja vaativiin kuljetustarpeisiin.\n\n",
                    "descren": "Renault Master is a reliable and handy van. ",
                    "notes": "- Auton korkeus on 2,5 m. SE EI MAHDU USEIMPIIN PARKKIHALLEIHIN!\n\n- Autossa on peruutuskamera, ei taustapeiliä.\n\n- Vältä käsijarrun käyttöä talviaikaan, etenkin varauksesi päätteeksi. Auton voi tasaisella jättää 1-vaihteelle ilman käsijarrua.\n \n- Renault-merkkisten autojen polttoainemittari näyttää usein täytenäkin vajaata. Tankkaa auto varauksesi päättyessä AINA täyteen ja säilytä kuitti. Jos epäilet tankanneesi enemmän kuin kulutit, täytä reklamaatio osoitteessa https://www.24rent.fi/polttoainereklamaatio.\n\n- Renault Master saattaa joskus näyttää seuraavat varoitukset: Injection fault tai Check emissions/engine. Ne johtuvat ajoittain ilmenevistä virheellisistä anturiarvoista. Mikäli muita varoituksia ei ilmaannu, autolla voi ajaa normaalisti.",
                    "notesen": "- The van is 2.5m high. DOES NOT FIT FOR INDOOR PARKING HALLS!\n- The van has a backup camera. It does not have a rear-view mirror nor cargo windows.\n- The fuel gauge may show inaccurate readings even when the tank is full. This is a known issue with this model and, unfortunately, something we cannot fix. If you are planning on making a complaint about the fuel level, refill the tank immediately after the pick up and keep the receipt.\n- Renault Master may sometimes display the following warning lights: Injection fault or Check emissions/engine. These are due to incorrect sensor readings. If no other warnings are shown, you can drive the van as usual.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "748_60_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "748_60_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "748_60_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "748_60_4_large.webp"
                    }
                ]
            },
            {
                "id": "890",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 6993.059010650412,
                "homeLocationData": {
                    "id": 160,
                    "address": "Karamzininranta 2, Aimo Park Finlandia",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.174454,
                        "longitude": 24.934465
                    },
                    "descriptions": {
                        "en": "In Aimo Park Finlandia -garage. Parking level -2 near the exit. Do not use the last 10 parking spots before exit doors!\r\n\r\n(https://www.24rent.fi/kulkuohje-aimo-parkeihin/)  ",
                        "fi": "Aimo Park Finlandia -pysäköintitalossa. Auto on tasolla -2 ulosajon läheisyydessä. Älä kuitenkaan käytä ensimmäistä kymmentä ruutua uloskäynniltä katsottaessa sujuvan kulkemisen varmistamiseksi.\r\n\r\n(Kulkuohjeet: https://www.24rent.fi/kulkuohje-aimo-parkeihin/) "
                    },
                    "fullAddress": "Karamzininranta 2, Aimo Park Finlandia, 00100 Helsinki",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Aimo Park Finlandia",
                    "postalCode": "00100",
                    "notes": "Ei pysäköintiä ensimmäiseen 10 ruutuun puomilta alkaen!",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2000,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [
                            "tuntiveloitus laskee pidemmissä vuokrauksissa"
                        ],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 35500,
                        "towHitch": 900,
                        "unlimitedKilometers": 2000,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 33500,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "automaattivaihteinen"
                ],
                "vehicleData": {
                    "id": 890,
                    "acriss": "",
                    "airbagCount": 1,
                    "brakedTowingCapacity": 2500,
                    "class": 1,
                    "co2Emissions": 194,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 26,
                    "currentMileage": 52506,
                    "currentVoltage": 12.06,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 103,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": true,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Toivonkatu 2, 00250 Helsinki",
                    "hybridity": "none",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1274,
                    "modelYear": 2020,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "YXH-110",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 50,
                        "dimensions": {
                            "trunkDepth": 345,
                            "trunkHeight": 196,
                            "trunkVolume": 11,
                            "trunkWidth": 181,
                            "vehicleHeight": 270,
                            "vehicleLength": 600,
                            "vehicleWidth": 210
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "VW",
                        "modelacriss": "",
                        "name": "Crafter aut",
                        "descr": "VW Crafter on erittäin mukava ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. \n\nVarustettu pysäköintitutkilla ja peruutuskameralla. ",
                        "descren": "VW Crafter is very comfortable and high quality option for bigger transportation needs.\n\nEquipped with rear view camera and parking sensors.\n",
                        "notes": "- Huomioi ajoneuvon korkeus vajaa 3m: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Automaattivaihteisto. Käynnistä jarrupoljin painettuna.\n\n- Mikäli joku ovista on raollaan, ei keskuslukitus lukitse ovia.\n\n- Jos ovet naksahtavat takaisin kiinni heti puhelimella avaamisen jälkeen, yritä uudelleen ja vedä kahvasti heti naksahduksen kuultuasi.",
                        "notesen": "- Almost 3 meters tall! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Automatic transmission. Press brake pedal while starting.\n\n- The doors are quite stiff to use. Please ensure that all doors are properly closed before locking them.\n\n- If the locks close right away when opened via portal, try again and immediately pull the handle when you hear the click. ",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 50,
                    "dimensions": {
                        "trunkDepth": 345,
                        "trunkHeight": 196,
                        "trunkVolume": 11,
                        "trunkWidth": 181,
                        "vehicleHeight": 270,
                        "vehicleLength": 600,
                        "vehicleWidth": 210
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "VW",
                    "modelacriss": "",
                    "name": "Crafter aut",
                    "descr": "VW Crafter on erittäin mukava ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. \n\nVarustettu pysäköintitutkilla ja peruutuskameralla. ",
                    "descren": "VW Crafter is very comfortable and high quality option for bigger transportation needs.\n\nEquipped with rear view camera and parking sensors.\n",
                    "notes": "- Huomioi ajoneuvon korkeus vajaa 3m: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Automaattivaihteisto. Käynnistä jarrupoljin painettuna.\n\n- Mikäli joku ovista on raollaan, ei keskuslukitus lukitse ovia.\n\n- Jos ovet naksahtavat takaisin kiinni heti puhelimella avaamisen jälkeen, yritä uudelleen ja vedä kahvasti heti naksahduksen kuultuasi.",
                    "notesen": "- Almost 3 meters tall! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Automatic transmission. Press brake pedal while starting.\n\n- The doors are quite stiff to use. Please ensure that all doors are properly closed before locking them.\n\n- If the locks close right away when opened via portal, try again and immediately pull the handle when you hear the click. ",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "525_50_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "525_50_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "525_50_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "525_50_4_large.webp"
                    }
                ]
            },
            {
                "id": "1211",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 6993.059010650412,
                "homeLocationData": {
                    "id": 160,
                    "address": "Karamzininranta 2, Aimo Park Finlandia",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.174454,
                        "longitude": 24.934465
                    },
                    "descriptions": {
                        "en": "In Aimo Park Finlandia -garage. Parking level -2 near the exit. Do not use the last 10 parking spots before exit doors!\r\n\r\n(https://www.24rent.fi/kulkuohje-aimo-parkeihin/)  ",
                        "fi": "Aimo Park Finlandia -pysäköintitalossa. Auto on tasolla -2 ulosajon läheisyydessä. Älä kuitenkaan käytä ensimmäistä kymmentä ruutua uloskäynniltä katsottaessa sujuvan kulkemisen varmistamiseksi.\r\n\r\n(Kulkuohjeet: https://www.24rent.fi/kulkuohje-aimo-parkeihin/) "
                    },
                    "fullAddress": "Karamzininranta 2, Aimo Park Finlandia, 00100 Helsinki",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Aimo Park Finlandia",
                    "postalCode": "00100",
                    "notes": "Ei pysäköintiä ensimmäiseen 10 ruutuun puomilta alkaen!",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2000,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [
                            "tuntiveloitus laskee pidemmissä vuokrauksissa"
                        ],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 33400,
                        "towHitch": 900,
                        "unlimitedKilometers": null,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 31400,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 1211,
                    "acriss": "",
                    "airbagCount": 1,
                    "brakedTowingCapacity": 2500,
                    "class": 1,
                    "co2Emissions": 247,
                    "consumptionInCity": 12,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 23,
                    "currentMileage": 30470,
                    "currentVoltage": 12.14,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2.3,
                    "enginePower": 110,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 6,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Mannerheimintie 13b, 00100 Helsinki",
                    "hybridity": "none",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1529,
                    "modelYear": 2021,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "JME-941",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 63,
                        "dimensions": {
                            "trunkDepth": 303,
                            "trunkHeight": 189,
                            "trunkVolume": 11,
                            "trunkWidth": 176,
                            "vehicleHeight": 260,
                            "vehicleLength": 558,
                            "vehicleWidth": 240
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Renault",
                        "modelacriss": "",
                        "name": "Master",
                        "descr": "Hyvä valinta myös suurempiin ja vaativampiin kuljetustarpeisiin. \n\nVarusteina mm. vakionopeudensäädin, peruutustutka ja -kamera, navigaattori, mäkilähtöavustin ja Extended grip –järjestelmä, AUX- ja USB-liitännät, Bluetooth, älypuhelinpeilaus Android Auto + Apple CarPlay",
                        "descren": "Renault Master is good option for a bigger transportation needs. \n",
                        "notes": "- Sininen merkkivalo kertoo kylmästä moottorista. Valo sammuu kun moottori lämpenee. Autoa voi käyttää normaalisti.\n\n- Vältä käsijarrun käyttöä talviaikaan, etenkin varauksesi päätteeksi. Auton voi tasaisella jättää 1-vaihteelle ilman käsijarrua.\n\n- Renault-merkkisten autojen polttoainemittari näyttää usein täytenäkin vajaata. Tankkaa auto varauksesi päättyessä AINA täyteen ja säilytä kuitti. Jos epäilet tankanneesi enemmän kuin kulutit, täytä reklamaatio osoitteessa https://www.24rent.fi/polttoainereklamaatio.",
                        "notesen": "- Blue warning light means that engine is cold. Light turns off when engine heats up. You can use the van normally.\n\n- The fuel gauge in many Renault models may show inaccurate readings even when the tank is full. ALWAYS fill up the tank before you return the vehicle and keep the receipt. If you feel you needed to fill up more than you used, please submit a fuel complaint at https://www.24rent.fi/polttoainereklamaatio.\n\n- Renault Master may sometimes display the following warning lights: Injection fault or Check emissions/engine. These are due to incorrect sensor readings. If no other warnings are shown, you can drive the van as usual.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 63,
                    "dimensions": {
                        "trunkDepth": 303,
                        "trunkHeight": 189,
                        "trunkVolume": 11,
                        "trunkWidth": 176,
                        "vehicleHeight": 260,
                        "vehicleLength": 558,
                        "vehicleWidth": 240
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Renault",
                    "modelacriss": "",
                    "name": "Master",
                    "descr": "Hyvä valinta myös suurempiin ja vaativampiin kuljetustarpeisiin. \n\nVarusteina mm. vakionopeudensäädin, peruutustutka ja -kamera, navigaattori, mäkilähtöavustin ja Extended grip –järjestelmä, AUX- ja USB-liitännät, Bluetooth, älypuhelinpeilaus Android Auto + Apple CarPlay",
                    "descren": "Renault Master is good option for a bigger transportation needs. \n",
                    "notes": "- Sininen merkkivalo kertoo kylmästä moottorista. Valo sammuu kun moottori lämpenee. Autoa voi käyttää normaalisti.\n\n- Vältä käsijarrun käyttöä talviaikaan, etenkin varauksesi päätteeksi. Auton voi tasaisella jättää 1-vaihteelle ilman käsijarrua.\n\n- Renault-merkkisten autojen polttoainemittari näyttää usein täytenäkin vajaata. Tankkaa auto varauksesi päättyessä AINA täyteen ja säilytä kuitti. Jos epäilet tankanneesi enemmän kuin kulutit, täytä reklamaatio osoitteessa https://www.24rent.fi/polttoainereklamaatio.",
                    "notesen": "- Blue warning light means that engine is cold. Light turns off when engine heats up. You can use the van normally.\n\n- The fuel gauge in many Renault models may show inaccurate readings even when the tank is full. ALWAYS fill up the tank before you return the vehicle and keep the receipt. If you feel you needed to fill up more than you used, please submit a fuel complaint at https://www.24rent.fi/polttoainereklamaatio.\n\n- Renault Master may sometimes display the following warning lights: Injection fault or Check emissions/engine. These are due to incorrect sensor readings. If no other warnings are shown, you can drive the van as usual.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "745_63_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "745_63_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "745_63_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "745_63_4_large.webp"
                    }
                ]
            },
            {
                "id": "1741",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 6993.059010650412,
                "homeLocationData": {
                    "id": 160,
                    "address": "Karamzininranta 2, Aimo Park Finlandia",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.174454,
                        "longitude": 24.934465
                    },
                    "descriptions": {
                        "en": "In Aimo Park Finlandia -garage. Parking level -2 near the exit. Do not use the last 10 parking spots before exit doors!\r\n\r\n(https://www.24rent.fi/kulkuohje-aimo-parkeihin/)  ",
                        "fi": "Aimo Park Finlandia -pysäköintitalossa. Auto on tasolla -2 ulosajon läheisyydessä. Älä kuitenkaan käytä ensimmäistä kymmentä ruutua uloskäynniltä katsottaessa sujuvan kulkemisen varmistamiseksi.\r\n\r\n(Kulkuohjeet: https://www.24rent.fi/kulkuohje-aimo-parkeihin/) "
                    },
                    "fullAddress": "Karamzininranta 2, Aimo Park Finlandia, 00100 Helsinki",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Aimo Park Finlandia",
                    "postalCode": "00100",
                    "notes": "Ei pysäköintiä ensimmäiseen 10 ruutuun puomilta alkaen!",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2500,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [
                            "tuntiveloitus laskee pidemmissä vuokrauksissa"
                        ],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 35500,
                        "towHitch": 900,
                        "unlimitedKilometers": 1500,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 33500,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 1741,
                    "acriss": "",
                    "airbagCount": 5,
                    "brakedTowingCapacity": 2500,
                    "class": 2,
                    "co2Emissions": 218,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 22,
                    "currentMileage": 3830,
                    "currentVoltage": 12.47,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 96,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Karamzininranta 2, 00100 Helsinki",
                    "hybridity": "normal",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1293,
                    "modelYear": 2022,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "JTO-269",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 76,
                        "dimensions": {
                            "trunkDepth": 353,
                            "trunkHeight": 188,
                            "trunkVolume": 11,
                            "trunkWidth": 178,
                            "vehicleHeight": 260,
                            "vehicleLength": 598,
                            "vehicleWidth": 250
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Ford",
                        "modelacriss": "",
                        "name": "Transit hybrid",
                        "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                        "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                        "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                        "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 76,
                    "dimensions": {
                        "trunkDepth": 353,
                        "trunkHeight": 188,
                        "trunkVolume": 11,
                        "trunkWidth": 178,
                        "vehicleHeight": 260,
                        "vehicleLength": 598,
                        "vehicleWidth": 250
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Ford",
                    "modelacriss": "",
                    "name": "Transit hybrid",
                    "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                    "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                    "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                    "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "1403_76_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "1403_76_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "1403_76_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "1403_76_4_large.webp"
                    }
                ]
            },
            {
                "id": "1775",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 7154.685734944389,
                "homeLocationData": {
                    "id": 227,
                    "address": "Helsingintie 1",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.21232,
                        "longitude": 24.73124
                    },
                    "descriptions": {
                        "en": "Park and Ride Kauniainen. ",
                        "fi": "Kauniaisten liityntäpysäköinnissä. "
                    },
                    "fullAddress": "Helsingintie 1, 02700 Kauniainen",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Rautatieasema",
                    "postalCode": "02700",
                    "notes": "",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2500,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 27500,
                        "towHitch": 900,
                        "unlimitedKilometers": 1500,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 25500,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 1775,
                    "acriss": "",
                    "airbagCount": 5,
                    "brakedTowingCapacity": 2500,
                    "class": 2,
                    "co2Emissions": 218,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 6695,
                    "currentMileage": 11090,
                    "currentVoltage": 12.75,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 96,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Helsingintie 2, 02700 Kauniainen",
                    "hybridity": "normal",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1293,
                    "modelYear": 2022,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "ZOE-588",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 76,
                        "dimensions": {
                            "trunkDepth": 353,
                            "trunkHeight": 188,
                            "trunkVolume": 11,
                            "trunkWidth": 178,
                            "vehicleHeight": 260,
                            "vehicleLength": 598,
                            "vehicleWidth": 250
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Ford",
                        "modelacriss": "",
                        "name": "Transit hybrid",
                        "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                        "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                        "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                        "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 76,
                    "dimensions": {
                        "trunkDepth": 353,
                        "trunkHeight": 188,
                        "trunkVolume": 11,
                        "trunkWidth": 178,
                        "vehicleHeight": 260,
                        "vehicleLength": 598,
                        "vehicleWidth": 250
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Ford",
                    "modelacriss": "",
                    "name": "Transit hybrid",
                    "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                    "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                    "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                    "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "1403_76_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "1403_76_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "1403_76_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "1403_76_4_large.webp"
                    }
                ]
            },
            {
                "id": "1738",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 7300.137624287468,
                "homeLocationData": {
                    "id": 1750,
                    "address": "Lapinlahdenkatu 16",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.167235,
                        "longitude": 24.922293
                    },
                    "descriptions": {
                        "en": "Parking place of Marian sairaala in the front yard. When returning the car, you can park in the back yard also if there is no available parking spots in the front yard.",
                        "fi": "Marian sairaalan sisäpihan pysäköintipaikoilla, yläpihalla. Ellei alueella ole tilaa autoa palautettaessa, voit pysäköidä myös alapihalle. "
                    },
                    "fullAddress": "Lapinlahdenkatu 16, 00101 Helsinki",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Kamppi",
                    "postalCode": "00101",
                    "notes": "",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2500,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [
                            "tuntiveloitus laskee pidemmissä vuokrauksissa"
                        ],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 35800,
                        "towHitch": 900,
                        "unlimitedKilometers": 1500,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 33800,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 1738,
                    "acriss": "",
                    "airbagCount": 5,
                    "brakedTowingCapacity": 2500,
                    "class": 2,
                    "co2Emissions": 218,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 141,
                    "currentMileage": 10292,
                    "currentVoltage": 12.6,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 96,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Mechelininkatu, 00180 Helsinki",
                    "hybridity": "normal",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1293,
                    "modelYear": 2022,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "YLJ-177",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 76,
                        "dimensions": {
                            "trunkDepth": 353,
                            "trunkHeight": 188,
                            "trunkVolume": 11,
                            "trunkWidth": 178,
                            "vehicleHeight": 260,
                            "vehicleLength": 598,
                            "vehicleWidth": 250
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Ford",
                        "modelacriss": "",
                        "name": "Transit hybrid",
                        "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                        "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                        "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                        "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 76,
                    "dimensions": {
                        "trunkDepth": 353,
                        "trunkHeight": 188,
                        "trunkVolume": 11,
                        "trunkWidth": 178,
                        "vehicleHeight": 260,
                        "vehicleLength": 598,
                        "vehicleWidth": 250
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Ford",
                    "modelacriss": "",
                    "name": "Transit hybrid",
                    "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                    "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                    "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                    "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "1403_76_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "1403_76_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "1403_76_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "1403_76_4_large.webp"
                    }
                ]
            },
            {
                "id": "1632",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 7465.658821831066,
                "homeLocationData": {
                    "id": 207,
                    "address": "Tammasaarenkatu 4",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.161591,
                        "longitude": 24.904609
                    },
                    "descriptions": {
                        "en": "Marked place in front of the DEF-ladder  at the plaza Kaapelinaukio.",
                        "fi": "Puolessa välissä Kaapelitehdasta Tammasaarenkadulla, DEF - sisäänkäynnin läheisyydessä 24Rent -autolle merkitty ruutu. "
                    },
                    "fullAddress": "Tammasaarenkatu 4, 00180 Helsinki",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Kaapelitehdas",
                    "postalCode": "00180",
                    "notes": "",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2500,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [
                            "tuntiveloitus laskee pidemmissä vuokrauksissa"
                        ],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 35800,
                        "towHitch": 900,
                        "unlimitedKilometers": 1500,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 33800,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 1632,
                    "acriss": "",
                    "airbagCount": 5,
                    "brakedTowingCapacity": 2500,
                    "class": 2,
                    "co2Emissions": 218,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 43,
                    "currentMileage": 5965,
                    "currentVoltage": 12.67,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 96,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Tammasaarenkatu 58, 00180 Helsinki",
                    "hybridity": "normal",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1293,
                    "modelYear": 2022,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "YLM-837",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 76,
                        "dimensions": {
                            "trunkDepth": 353,
                            "trunkHeight": 188,
                            "trunkVolume": 11,
                            "trunkWidth": 178,
                            "vehicleHeight": 260,
                            "vehicleLength": 598,
                            "vehicleWidth": 250
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Ford",
                        "modelacriss": "",
                        "name": "Transit hybrid",
                        "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                        "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                        "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                        "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 76,
                    "dimensions": {
                        "trunkDepth": 353,
                        "trunkHeight": 188,
                        "trunkVolume": 11,
                        "trunkWidth": 178,
                        "vehicleHeight": 260,
                        "vehicleLength": 598,
                        "vehicleWidth": 250
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Ford",
                    "modelacriss": "",
                    "name": "Transit hybrid",
                    "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                    "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                    "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                    "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "1403_76_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "1403_76_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "1403_76_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "1403_76_4_large.webp"
                    }
                ]
            },
            {
                "id": "1696",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 7804.620385213472,
                "homeLocationData": {
                    "id": 5544,
                    "address": "Ersintie 15",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.209133,
                        "longitude": 24.720583
                    },
                    "descriptions": {
                        "en": "Unlimited on-street parking along Ersintie.",
                        "fi": "Ersintien varressa vapaa kadunvarsipysäköinti"
                    },
                    "fullAddress": "Ersintie 15, 02700 Kauniainen",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Kauniainen",
                    "postalCode": "02700",
                    "notes": "Varakatuna Kirkkotie ",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2500,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 26200,
                        "towHitch": 900,
                        "unlimitedKilometers": 1900,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 24200,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 1696,
                    "acriss": "",
                    "airbagCount": 5,
                    "brakedTowingCapacity": 2500,
                    "class": 2,
                    "co2Emissions": 218,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 38,
                    "currentMileage": 20795,
                    "currentVoltage": 12.63,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 96,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Ersintie 15, 02700 Kauniainen",
                    "hybridity": "normal",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1293,
                    "modelYear": 2022,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "YLM-838",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 76,
                        "dimensions": {
                            "trunkDepth": 353,
                            "trunkHeight": 188,
                            "trunkVolume": 11,
                            "trunkWidth": 178,
                            "vehicleHeight": 260,
                            "vehicleLength": 598,
                            "vehicleWidth": 250
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Ford",
                        "modelacriss": "",
                        "name": "Transit hybrid",
                        "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                        "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                        "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                        "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 76,
                    "dimensions": {
                        "trunkDepth": 353,
                        "trunkHeight": 188,
                        "trunkVolume": 11,
                        "trunkWidth": 178,
                        "vehicleHeight": 260,
                        "vehicleLength": 598,
                        "vehicleWidth": 250
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Ford",
                    "modelacriss": "",
                    "name": "Transit hybrid",
                    "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                    "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                    "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                    "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "1403_76_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "1403_76_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "1403_76_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "1403_76_4_large.webp"
                    }
                ]
            },
            {
                "id": "877",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 8195.123761161574,
                "homeLocationData": {
                    "id": 162,
                    "address": "Yrjönkatu 10, Aimo Park",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.164511,
                        "longitude": 24.943907
                    },
                    "descriptions": {
                        "en": "Aimo Park Iso-Erottaja parking garage.(https://www.24rent.fi/kulkuohje-aimo-parkeihin).\r\n\r\nAccess for pedestrians: Bulevardi 2-4 next to Klaus K hotell, Korkeavuorenkatu 45 or Ludviginkatu 4. Please notice that the garage has bad internet coverage so use the text message code to open and close the car doors. Parking area 5. \r\n\r\nWhen parking garage is closed. Use the access card at the gate or contact Aimo Park via their info button.",
                        "fi": "Aimo Park Iso-Erottaja -parkkitalossa. (kulkuohjeet: https://www.24rent.fi/kulkuohje-aimo-parkeihin). Jalankulku halliin: Bulevardi 2-4 hotellin Klaus K vierestä, Korkeavuorenkatu 45 tai Ludviginkatu 4. Pysäköinti ensisijaisesti käytävällä 5. Huomioithan, että tietyillä operaattoreilla on hallissa huono verkkokuuluvuus, mutta voit aloittaa ja lopettaa varauksen myös tekstiviestillä. \r\n\r\nParkkihallin ollessa suljettu, näytä kulkukorttia ovien ulkopuolella olevaan ovilukijaan tai pyydä laitteen info-painikkeen kautta oven avaus."
                    },
                    "fullAddress": "Yrjönkatu 10, Aimo Park, 00120 Helsinki",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Keskusta - Erottaja",
                    "postalCode": "00120",
                    "notes": "Pysäköi pakettiauto ruutuun aina keula edellä!\r\n\r\nHUOM! Osa parkkihallista kyltteineen ovat matalammalla ajokorkeudella. Älä aja pakettiautolla tällaisille alueille (esim. Pikku Erottaja)!\r\n \r\nhttps://www.aimopark.fi/fi-fi/cities/helsinki/iso-erottaja/",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2000,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 28600,
                        "towHitch": 900,
                        "unlimitedKilometers": 2000,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 26600,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "automaattivaihteinen"
                ],
                "vehicleData": {
                    "id": 877,
                    "acriss": "",
                    "airbagCount": 1,
                    "brakedTowingCapacity": 2500,
                    "class": 1,
                    "co2Emissions": 194,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 55,
                    "currentMileage": 44836,
                    "currentVoltage": 11.88,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 103,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": true,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Yrjönkatu 12a, 00120 Helsinki",
                    "hybridity": "none",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1274,
                    "modelYear": 2020,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "YKJ-417",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 50,
                        "dimensions": {
                            "trunkDepth": 345,
                            "trunkHeight": 196,
                            "trunkVolume": 11,
                            "trunkWidth": 181,
                            "vehicleHeight": 270,
                            "vehicleLength": 600,
                            "vehicleWidth": 210
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "VW",
                        "modelacriss": "",
                        "name": "Crafter aut",
                        "descr": "VW Crafter on erittäin mukava ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. \n\nVarustettu pysäköintitutkilla ja peruutuskameralla. ",
                        "descren": "VW Crafter is very comfortable and high quality option for bigger transportation needs.\n\nEquipped with rear view camera and parking sensors.\n",
                        "notes": "- Huomioi ajoneuvon korkeus vajaa 3m: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Automaattivaihteisto. Käynnistä jarrupoljin painettuna.\n\n- Mikäli joku ovista on raollaan, ei keskuslukitus lukitse ovia.\n\n- Jos ovet naksahtavat takaisin kiinni heti puhelimella avaamisen jälkeen, yritä uudelleen ja vedä kahvasti heti naksahduksen kuultuasi.",
                        "notesen": "- Almost 3 meters tall! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Automatic transmission. Press brake pedal while starting.\n\n- The doors are quite stiff to use. Please ensure that all doors are properly closed before locking them.\n\n- If the locks close right away when opened via portal, try again and immediately pull the handle when you hear the click. ",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 50,
                    "dimensions": {
                        "trunkDepth": 345,
                        "trunkHeight": 196,
                        "trunkVolume": 11,
                        "trunkWidth": 181,
                        "vehicleHeight": 270,
                        "vehicleLength": 600,
                        "vehicleWidth": 210
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "VW",
                    "modelacriss": "",
                    "name": "Crafter aut",
                    "descr": "VW Crafter on erittäin mukava ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. \n\nVarustettu pysäköintitutkilla ja peruutuskameralla. ",
                    "descren": "VW Crafter is very comfortable and high quality option for bigger transportation needs.\n\nEquipped with rear view camera and parking sensors.\n",
                    "notes": "- Huomioi ajoneuvon korkeus vajaa 3m: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Automaattivaihteisto. Käynnistä jarrupoljin painettuna.\n\n- Mikäli joku ovista on raollaan, ei keskuslukitus lukitse ovia.\n\n- Jos ovet naksahtavat takaisin kiinni heti puhelimella avaamisen jälkeen, yritä uudelleen ja vedä kahvasti heti naksahduksen kuultuasi.",
                    "notesen": "- Almost 3 meters tall! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Automatic transmission. Press brake pedal while starting.\n\n- The doors are quite stiff to use. Please ensure that all doors are properly closed before locking them.\n\n- If the locks close right away when opened via portal, try again and immediately pull the handle when you hear the click. ",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "525_50_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "525_50_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "525_50_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "525_50_4_large.webp"
                    }
                ]
            },
            {
                "id": "885",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 8195.123761161574,
                "homeLocationData": {
                    "id": 162,
                    "address": "Yrjönkatu 10, Aimo Park",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.164511,
                        "longitude": 24.943907
                    },
                    "descriptions": {
                        "en": "Aimo Park Iso-Erottaja parking garage.(https://www.24rent.fi/kulkuohje-aimo-parkeihin).\r\n\r\nAccess for pedestrians: Bulevardi 2-4 next to Klaus K hotell, Korkeavuorenkatu 45 or Ludviginkatu 4. Please notice that the garage has bad internet coverage so use the text message code to open and close the car doors. Parking area 5. \r\n\r\nWhen parking garage is closed. Use the access card at the gate or contact Aimo Park via their info button.",
                        "fi": "Aimo Park Iso-Erottaja -parkkitalossa. (kulkuohjeet: https://www.24rent.fi/kulkuohje-aimo-parkeihin). Jalankulku halliin: Bulevardi 2-4 hotellin Klaus K vierestä, Korkeavuorenkatu 45 tai Ludviginkatu 4. Pysäköinti ensisijaisesti käytävällä 5. Huomioithan, että tietyillä operaattoreilla on hallissa huono verkkokuuluvuus, mutta voit aloittaa ja lopettaa varauksen myös tekstiviestillä. \r\n\r\nParkkihallin ollessa suljettu, näytä kulkukorttia ovien ulkopuolella olevaan ovilukijaan tai pyydä laitteen info-painikkeen kautta oven avaus."
                    },
                    "fullAddress": "Yrjönkatu 10, Aimo Park, 00120 Helsinki",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Keskusta - Erottaja",
                    "postalCode": "00120",
                    "notes": "Pysäköi pakettiauto ruutuun aina keula edellä!\r\n\r\nHUOM! Osa parkkihallista kyltteineen ovat matalammalla ajokorkeudella. Älä aja pakettiautolla tällaisille alueille (esim. Pikku Erottaja)!\r\n \r\nhttps://www.aimopark.fi/fi-fi/cities/helsinki/iso-erottaja/",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2000,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 26900,
                        "towHitch": 900,
                        "unlimitedKilometers": 1500,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 24900,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "baltia",
                    "viro",
                    "latvia",
                    "liettua",
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 885,
                    "acriss": "",
                    "airbagCount": 1,
                    "brakedTowingCapacity": 2500,
                    "class": 1,
                    "co2Emissions": 247,
                    "consumptionInCity": 12,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 59,
                    "currentMileage": 53497,
                    "currentVoltage": 12.06,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2.3,
                    "enginePower": 110,
                    "exportPermits": {
                        "balticStates": true,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 6,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Yrjönkatu 12a, 00120 Helsinki",
                    "hybridity": "none",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1529,
                    "modelYear": 2020,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "YXB-407",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 63,
                        "dimensions": {
                            "trunkDepth": 303,
                            "trunkHeight": 189,
                            "trunkVolume": 11,
                            "trunkWidth": 176,
                            "vehicleHeight": 260,
                            "vehicleLength": 558,
                            "vehicleWidth": 240
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Renault",
                        "modelacriss": "",
                        "name": "Master",
                        "descr": "Hyvä valinta myös suurempiin ja vaativampiin kuljetustarpeisiin. \n\nVarusteina mm. vakionopeudensäädin, peruutustutka ja -kamera, navigaattori, mäkilähtöavustin ja Extended grip –järjestelmä, AUX- ja USB-liitännät, Bluetooth, älypuhelinpeilaus Android Auto + Apple CarPlay",
                        "descren": "Renault Master is good option for a bigger transportation needs. \n",
                        "notes": "- Sininen merkkivalo kertoo kylmästä moottorista. Valo sammuu kun moottori lämpenee. Autoa voi käyttää normaalisti.\n\n- Vältä käsijarrun käyttöä talviaikaan, etenkin varauksesi päätteeksi. Auton voi tasaisella jättää 1-vaihteelle ilman käsijarrua.\n\n- Renault-merkkisten autojen polttoainemittari näyttää usein täytenäkin vajaata. Tankkaa auto varauksesi päättyessä AINA täyteen ja säilytä kuitti. Jos epäilet tankanneesi enemmän kuin kulutit, täytä reklamaatio osoitteessa https://www.24rent.fi/polttoainereklamaatio.",
                        "notesen": "- Blue warning light means that engine is cold. Light turns off when engine heats up. You can use the van normally.\n\n- The fuel gauge in many Renault models may show inaccurate readings even when the tank is full. ALWAYS fill up the tank before you return the vehicle and keep the receipt. If you feel you needed to fill up more than you used, please submit a fuel complaint at https://www.24rent.fi/polttoainereklamaatio.\n\n- Renault Master may sometimes display the following warning lights: Injection fault or Check emissions/engine. These are due to incorrect sensor readings. If no other warnings are shown, you can drive the van as usual.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 63,
                    "dimensions": {
                        "trunkDepth": 303,
                        "trunkHeight": 189,
                        "trunkVolume": 11,
                        "trunkWidth": 176,
                        "vehicleHeight": 260,
                        "vehicleLength": 558,
                        "vehicleWidth": 240
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Renault",
                    "modelacriss": "",
                    "name": "Master",
                    "descr": "Hyvä valinta myös suurempiin ja vaativampiin kuljetustarpeisiin. \n\nVarusteina mm. vakionopeudensäädin, peruutustutka ja -kamera, navigaattori, mäkilähtöavustin ja Extended grip –järjestelmä, AUX- ja USB-liitännät, Bluetooth, älypuhelinpeilaus Android Auto + Apple CarPlay",
                    "descren": "Renault Master is good option for a bigger transportation needs. \n",
                    "notes": "- Sininen merkkivalo kertoo kylmästä moottorista. Valo sammuu kun moottori lämpenee. Autoa voi käyttää normaalisti.\n\n- Vältä käsijarrun käyttöä talviaikaan, etenkin varauksesi päätteeksi. Auton voi tasaisella jättää 1-vaihteelle ilman käsijarrua.\n\n- Renault-merkkisten autojen polttoainemittari näyttää usein täytenäkin vajaata. Tankkaa auto varauksesi päättyessä AINA täyteen ja säilytä kuitti. Jos epäilet tankanneesi enemmän kuin kulutit, täytä reklamaatio osoitteessa https://www.24rent.fi/polttoainereklamaatio.",
                    "notesen": "- Blue warning light means that engine is cold. Light turns off when engine heats up. You can use the van normally.\n\n- The fuel gauge in many Renault models may show inaccurate readings even when the tank is full. ALWAYS fill up the tank before you return the vehicle and keep the receipt. If you feel you needed to fill up more than you used, please submit a fuel complaint at https://www.24rent.fi/polttoainereklamaatio.\n\n- Renault Master may sometimes display the following warning lights: Injection fault or Check emissions/engine. These are due to incorrect sensor readings. If no other warnings are shown, you can drive the van as usual.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "745_63_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "745_63_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "745_63_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "745_63_4_large.webp"
                    }
                ]
            },
            {
                "id": "1634",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 8195.123761161574,
                "homeLocationData": {
                    "id": 162,
                    "address": "Yrjönkatu 10, Aimo Park",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.164511,
                        "longitude": 24.943907
                    },
                    "descriptions": {
                        "en": "Aimo Park Iso-Erottaja parking garage.(https://www.24rent.fi/kulkuohje-aimo-parkeihin).\r\n\r\nAccess for pedestrians: Bulevardi 2-4 next to Klaus K hotell, Korkeavuorenkatu 45 or Ludviginkatu 4. Please notice that the garage has bad internet coverage so use the text message code to open and close the car doors. Parking area 5. \r\n\r\nWhen parking garage is closed. Use the access card at the gate or contact Aimo Park via their info button.",
                        "fi": "Aimo Park Iso-Erottaja -parkkitalossa. (kulkuohjeet: https://www.24rent.fi/kulkuohje-aimo-parkeihin). Jalankulku halliin: Bulevardi 2-4 hotellin Klaus K vierestä, Korkeavuorenkatu 45 tai Ludviginkatu 4. Pysäköinti ensisijaisesti käytävällä 5. Huomioithan, että tietyillä operaattoreilla on hallissa huono verkkokuuluvuus, mutta voit aloittaa ja lopettaa varauksen myös tekstiviestillä. \r\n\r\nParkkihallin ollessa suljettu, näytä kulkukorttia ovien ulkopuolella olevaan ovilukijaan tai pyydä laitteen info-painikkeen kautta oven avaus."
                    },
                    "fullAddress": "Yrjönkatu 10, Aimo Park, 00120 Helsinki",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Keskusta - Erottaja",
                    "postalCode": "00120",
                    "notes": "Pysäköi pakettiauto ruutuun aina keula edellä!\r\n\r\nHUOM! Osa parkkihallista kyltteineen ovat matalammalla ajokorkeudella. Älä aja pakettiautolla tällaisille alueille (esim. Pikku Erottaja)!\r\n \r\nhttps://www.aimopark.fi/fi-fi/cities/helsinki/iso-erottaja/",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2500,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 28600,
                        "towHitch": 900,
                        "unlimitedKilometers": 1500,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 26600,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 1634,
                    "acriss": "",
                    "airbagCount": 5,
                    "brakedTowingCapacity": 2500,
                    "class": 2,
                    "co2Emissions": 218,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 23,
                    "currentMileage": 5646,
                    "currentVoltage": 12.76,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 96,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Yrjönkatu 8, 00120 Helsinki",
                    "hybridity": "normal",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1293,
                    "modelYear": 2022,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "IPE-288",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 76,
                        "dimensions": {
                            "trunkDepth": 353,
                            "trunkHeight": 188,
                            "trunkVolume": 11,
                            "trunkWidth": 178,
                            "vehicleHeight": 260,
                            "vehicleLength": 598,
                            "vehicleWidth": 250
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Ford",
                        "modelacriss": "",
                        "name": "Transit hybrid",
                        "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                        "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                        "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                        "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 76,
                    "dimensions": {
                        "trunkDepth": 353,
                        "trunkHeight": 188,
                        "trunkVolume": 11,
                        "trunkWidth": 178,
                        "vehicleHeight": 260,
                        "vehicleLength": 598,
                        "vehicleWidth": 250
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Ford",
                    "modelacriss": "",
                    "name": "Transit hybrid",
                    "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                    "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                    "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                    "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "1403_76_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "1403_76_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "1403_76_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "1403_76_4_large.webp"
                    }
                ]
            },
            {
                "id": "891",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 8351.628804243928,
                "homeLocationData": {
                    "id": 4699,
                    "address": "Pihlajistonkuja 4",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.229686,
                        "longitude": 25.008998
                    },
                    "descriptions": {
                        "en": "The van is in the Pelican Self Storage parking lot. The Pelican staff is not involved in the rental process. Do not park in front of doors or gates.",
                        "fi": "Auto sijaitsee Pelican Self Storagen parkkipaikalla. Pelicanin henkilökunta EI osallistu vuokraukseen. Ei saa pysäköidä ovien, nosto-ovien tai porttien eteen."
                    },
                    "fullAddress": "Pihlajistonkuja 4, 00710 Helsinki",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Viikki - Pelican",
                    "postalCode": "00710",
                    "notes": "",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2000,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 26700,
                        "towHitch": 900,
                        "unlimitedKilometers": 2000,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 24700,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "automaattivaihteinen"
                ],
                "vehicleData": {
                    "id": 891,
                    "acriss": "",
                    "airbagCount": 1,
                    "brakedTowingCapacity": 2500,
                    "class": 1,
                    "co2Emissions": 194,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 5,
                    "currentMileage": 48659,
                    "currentVoltage": 12.17,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 103,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": true,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Pihlajistonkuja 6, 00710 Helsinki",
                    "hybridity": "none",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1274,
                    "modelYear": 2020,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "ESE-591",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 50,
                        "dimensions": {
                            "trunkDepth": 345,
                            "trunkHeight": 196,
                            "trunkVolume": 11,
                            "trunkWidth": 181,
                            "vehicleHeight": 270,
                            "vehicleLength": 600,
                            "vehicleWidth": 210
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "VW",
                        "modelacriss": "",
                        "name": "Crafter aut",
                        "descr": "VW Crafter on erittäin mukava ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. \n\nVarustettu pysäköintitutkilla ja peruutuskameralla. ",
                        "descren": "VW Crafter is very comfortable and high quality option for bigger transportation needs.\n\nEquipped with rear view camera and parking sensors.\n",
                        "notes": "- Huomioi ajoneuvon korkeus vajaa 3m: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Automaattivaihteisto. Käynnistä jarrupoljin painettuna.\n\n- Mikäli joku ovista on raollaan, ei keskuslukitus lukitse ovia.\n\n- Jos ovet naksahtavat takaisin kiinni heti puhelimella avaamisen jälkeen, yritä uudelleen ja vedä kahvasti heti naksahduksen kuultuasi.",
                        "notesen": "- Almost 3 meters tall! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Automatic transmission. Press brake pedal while starting.\n\n- The doors are quite stiff to use. Please ensure that all doors are properly closed before locking them.\n\n- If the locks close right away when opened via portal, try again and immediately pull the handle when you hear the click. ",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 50,
                    "dimensions": {
                        "trunkDepth": 345,
                        "trunkHeight": 196,
                        "trunkVolume": 11,
                        "trunkWidth": 181,
                        "vehicleHeight": 270,
                        "vehicleLength": 600,
                        "vehicleWidth": 210
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "VW",
                    "modelacriss": "",
                    "name": "Crafter aut",
                    "descr": "VW Crafter on erittäin mukava ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. \n\nVarustettu pysäköintitutkilla ja peruutuskameralla. ",
                    "descren": "VW Crafter is very comfortable and high quality option for bigger transportation needs.\n\nEquipped with rear view camera and parking sensors.\n",
                    "notes": "- Huomioi ajoneuvon korkeus vajaa 3m: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Automaattivaihteisto. Käynnistä jarrupoljin painettuna.\n\n- Mikäli joku ovista on raollaan, ei keskuslukitus lukitse ovia.\n\n- Jos ovet naksahtavat takaisin kiinni heti puhelimella avaamisen jälkeen, yritä uudelleen ja vedä kahvasti heti naksahduksen kuultuasi.",
                    "notesen": "- Almost 3 meters tall! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Automatic transmission. Press brake pedal while starting.\n\n- The doors are quite stiff to use. Please ensure that all doors are properly closed before locking them.\n\n- If the locks close right away when opened via portal, try again and immediately pull the handle when you hear the click. ",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "525_50_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "525_50_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "525_50_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "525_50_4_large.webp"
                    }
                ]
            },
            {
                "id": "1688",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 8568.777386041944,
                "homeLocationData": {
                    "id": 67,
                    "address": "Koskelonpiha 1",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.259752,
                        "longitude": 24.720318
                    },
                    "descriptions": {
                        "en": "Free parking on the side of the road",
                        "fi": "Ilmainen kadunvarsipysäköinti. "
                    },
                    "fullAddress": "Koskelonpiha 1, 02920 Espoo",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Koskelo",
                    "postalCode": "02920",
                    "notes": "",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2500,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 26000,
                        "towHitch": 900,
                        "unlimitedKilometers": 1500,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 24000,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 1688,
                    "acriss": "",
                    "airbagCount": 5,
                    "brakedTowingCapacity": 2500,
                    "class": 2,
                    "co2Emissions": 218,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 93,
                    "currentMileage": 5565,
                    "currentVoltage": 12.39,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 96,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Koskelonpiha 2, 02920 Espoo",
                    "hybridity": "normal",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1293,
                    "modelYear": 2022,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "JIZ-179",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 76,
                        "dimensions": {
                            "trunkDepth": 353,
                            "trunkHeight": 188,
                            "trunkVolume": 11,
                            "trunkWidth": 178,
                            "vehicleHeight": 260,
                            "vehicleLength": 598,
                            "vehicleWidth": 250
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Ford",
                        "modelacriss": "",
                        "name": "Transit hybrid",
                        "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                        "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                        "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                        "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 76,
                    "dimensions": {
                        "trunkDepth": 353,
                        "trunkHeight": 188,
                        "trunkVolume": 11,
                        "trunkWidth": 178,
                        "vehicleHeight": 260,
                        "vehicleLength": 598,
                        "vehicleWidth": 250
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Ford",
                    "modelacriss": "",
                    "name": "Transit hybrid",
                    "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                    "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                    "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                    "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "1403_76_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "1403_76_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "1403_76_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "1403_76_4_large.webp"
                    }
                ]
            },
            {
                "id": "1773",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 8908.973938647236,
                "homeLocationData": {
                    "id": 174,
                    "address": "Tammiston Kauppatie 10",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.28165,
                        "longitude": 24.971331
                    },
                    "descriptions": {
                        "en": "On the Plantagen parking lot. You can leave your own car in the parking lot.",
                        "fi": "Plantagenin parkkipaikalla. Omalle autolle tilaa parkkipaikalla."
                    },
                    "fullAddress": "Tammiston Kauppatie 10, 01510 Vantaa",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Kartanonkoski",
                    "postalCode": "01510",
                    "notes": "",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2500,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [
                            "tuntiveloitus laskee pidemmissä vuokrauksissa"
                        ],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 33200,
                        "towHitch": 900,
                        "unlimitedKilometers": 1500,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 31200,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 1773,
                    "acriss": "",
                    "airbagCount": 5,
                    "brakedTowingCapacity": 2500,
                    "class": 2,
                    "co2Emissions": 218,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 72,
                    "currentMileage": 4634,
                    "currentVoltage": 12.35,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 96,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Hagelstamintie 30, 01520 Vantaa",
                    "hybridity": "normal",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1293,
                    "modelYear": 2022,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "JIZ-182",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 76,
                        "dimensions": {
                            "trunkDepth": 353,
                            "trunkHeight": 188,
                            "trunkVolume": 11,
                            "trunkWidth": 178,
                            "vehicleHeight": 260,
                            "vehicleLength": 598,
                            "vehicleWidth": 250
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Ford",
                        "modelacriss": "",
                        "name": "Transit hybrid",
                        "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                        "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                        "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                        "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 76,
                    "dimensions": {
                        "trunkDepth": 353,
                        "trunkHeight": 188,
                        "trunkVolume": 11,
                        "trunkWidth": 178,
                        "vehicleHeight": 260,
                        "vehicleLength": 598,
                        "vehicleWidth": 250
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Ford",
                    "modelacriss": "",
                    "name": "Transit hybrid",
                    "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                    "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                    "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                    "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "1403_76_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "1403_76_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "1403_76_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "1403_76_4_large.webp"
                    }
                ]
            },
            {
                "id": "856",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 8928.637279004512,
                "homeLocationData": {
                    "id": 6749,
                    "address": "Marsalkantie 16",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.183825,
                        "longitude": 24.997293
                    },
                    "descriptions": {
                        "en": "24h parking lot.",
                        "fi": "24h pysäköintialue"
                    },
                    "fullAddress": "Marsalkantie 16, Suomi Helsinki",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Kulosaari",
                    "postalCode": "Suomi",
                    "notes": "",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2000,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 27600,
                        "towHitch": 900,
                        "unlimitedKilometers": 1500,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 25600,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 856,
                    "acriss": "",
                    "airbagCount": 1,
                    "brakedTowingCapacity": 2500,
                    "class": 1,
                    "co2Emissions": 249,
                    "consumptionInCity": 12,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10.5,
                    "currentDistanceToHome": 25,
                    "currentMileage": 64545,
                    "currentVoltage": 12.06,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2.3,
                    "enginePower": 110,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 6,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Marsalkantie 16, Helsinki",
                    "hybridity": "none",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1434,
                    "modelYear": 2020,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "YXE-617",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 60,
                        "dimensions": {
                            "trunkDepth": 373,
                            "trunkHeight": 189,
                            "trunkVolume": 13,
                            "trunkWidth": 176,
                            "vehicleHeight": 260,
                            "vehicleLength": 620,
                            "vehicleWidth": 210
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Renault",
                        "modelacriss": "",
                        "name": "Master",
                        "descr": "Renault Master on hyvä valinta myös suuriin ja vaativiin kuljetustarpeisiin.\n\n",
                        "descren": "Renault Master is a reliable and handy van. ",
                        "notes": "- Auton korkeus on 2,5 m. SE EI MAHDU USEIMPIIN PARKKIHALLEIHIN!\n\n- Autossa on peruutuskamera, ei taustapeiliä.\n\n- Vältä käsijarrun käyttöä talviaikaan, etenkin varauksesi päätteeksi. Auton voi tasaisella jättää 1-vaihteelle ilman käsijarrua.\n \n- Renault-merkkisten autojen polttoainemittari näyttää usein täytenäkin vajaata. Tankkaa auto varauksesi päättyessä AINA täyteen ja säilytä kuitti. Jos epäilet tankanneesi enemmän kuin kulutit, täytä reklamaatio osoitteessa https://www.24rent.fi/polttoainereklamaatio.\n\n- Renault Master saattaa joskus näyttää seuraavat varoitukset: Injection fault tai Check emissions/engine. Ne johtuvat ajoittain ilmenevistä virheellisistä anturiarvoista. Mikäli muita varoituksia ei ilmaannu, autolla voi ajaa normaalisti.",
                        "notesen": "- The van is 2.5m high. DOES NOT FIT FOR INDOOR PARKING HALLS!\n- The van has a backup camera. It does not have a rear-view mirror nor cargo windows.\n- The fuel gauge may show inaccurate readings even when the tank is full. This is a known issue with this model and, unfortunately, something we cannot fix. If you are planning on making a complaint about the fuel level, refill the tank immediately after the pick up and keep the receipt.\n- Renault Master may sometimes display the following warning lights: Injection fault or Check emissions/engine. These are due to incorrect sensor readings. If no other warnings are shown, you can drive the van as usual.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 60,
                    "dimensions": {
                        "trunkDepth": 373,
                        "trunkHeight": 189,
                        "trunkVolume": 13,
                        "trunkWidth": 176,
                        "vehicleHeight": 260,
                        "vehicleLength": 620,
                        "vehicleWidth": 210
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Renault",
                    "modelacriss": "",
                    "name": "Master",
                    "descr": "Renault Master on hyvä valinta myös suuriin ja vaativiin kuljetustarpeisiin.\n\n",
                    "descren": "Renault Master is a reliable and handy van. ",
                    "notes": "- Auton korkeus on 2,5 m. SE EI MAHDU USEIMPIIN PARKKIHALLEIHIN!\n\n- Autossa on peruutuskamera, ei taustapeiliä.\n\n- Vältä käsijarrun käyttöä talviaikaan, etenkin varauksesi päätteeksi. Auton voi tasaisella jättää 1-vaihteelle ilman käsijarrua.\n \n- Renault-merkkisten autojen polttoainemittari näyttää usein täytenäkin vajaata. Tankkaa auto varauksesi päättyessä AINA täyteen ja säilytä kuitti. Jos epäilet tankanneesi enemmän kuin kulutit, täytä reklamaatio osoitteessa https://www.24rent.fi/polttoainereklamaatio.\n\n- Renault Master saattaa joskus näyttää seuraavat varoitukset: Injection fault tai Check emissions/engine. Ne johtuvat ajoittain ilmenevistä virheellisistä anturiarvoista. Mikäli muita varoituksia ei ilmaannu, autolla voi ajaa normaalisti.",
                    "notesen": "- The van is 2.5m high. DOES NOT FIT FOR INDOOR PARKING HALLS!\n- The van has a backup camera. It does not have a rear-view mirror nor cargo windows.\n- The fuel gauge may show inaccurate readings even when the tank is full. This is a known issue with this model and, unfortunately, something we cannot fix. If you are planning on making a complaint about the fuel level, refill the tank immediately after the pick up and keep the receipt.\n- Renault Master may sometimes display the following warning lights: Injection fault or Check emissions/engine. These are due to incorrect sensor readings. If no other warnings are shown, you can drive the van as usual.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "748_60_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "748_60_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "748_60_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "748_60_4_large.webp"
                    }
                ]
            },
            {
                "id": "1488",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": true
                },
                "distance": 9072.764866712712,
                "homeLocationData": {
                    "id": 6732,
                    "address": "Mellstenintie 15",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.154449,
                        "longitude": 24.774718
                    },
                    "descriptions": {
                        "en": "24h parking lot. Use the spaces close to the street.",
                        "fi": "24h pysäköintialue kadun vieressä. Käytä kadun puoleisia pysäköintipaikkoja."
                    },
                    "fullAddress": "Mellstenintie 15, 02170 Espoo",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Haukilahti",
                    "postalCode": "02170",
                    "notes": "",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2500,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 26500,
                        "towHitch": 900,
                        "unlimitedKilometers": 1500,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 24500,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 1488,
                    "acriss": "",
                    "airbagCount": 5,
                    "brakedTowingCapacity": 2500,
                    "class": 2,
                    "co2Emissions": 218,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 24,
                    "currentMileage": 17753,
                    "currentVoltage": 12.54,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 96,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Mellstenintie 15h, 02170 Espoo",
                    "hybridity": "normal",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1293,
                    "modelYear": 2022,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "YLM-831",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 76,
                        "dimensions": {
                            "trunkDepth": 353,
                            "trunkHeight": 188,
                            "trunkVolume": 11,
                            "trunkWidth": 178,
                            "vehicleHeight": 260,
                            "vehicleLength": 598,
                            "vehicleWidth": 250
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Ford",
                        "modelacriss": "",
                        "name": "Transit hybrid",
                        "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                        "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                        "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                        "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 76,
                    "dimensions": {
                        "trunkDepth": 353,
                        "trunkHeight": 188,
                        "trunkVolume": 11,
                        "trunkWidth": 178,
                        "vehicleHeight": 260,
                        "vehicleLength": 598,
                        "vehicleWidth": 250
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Ford",
                    "modelacriss": "",
                    "name": "Transit hybrid",
                    "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                    "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                    "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                    "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "1403_76_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "1403_76_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "1403_76_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "1403_76_4_large.webp"
                    }
                ]
            },
            {
                "id": "1665",
                "parkingPermit" :{
                    "valid": false
                },
                "availabilityData": {
                    "available": false
                },
                "distance": 5939.7596825964465,
                "homeLocationData": {
                    "id": 62,
                    "address": "Karapellontie 13",
                    "automaticallyCreated": false,
                    "coordinates": {
                        "latitude": 60.216721,
                        "longitude": 24.752
                    },
                    "descriptions": {
                        "en": "Parking lot at the end of  Karapellontie.",
                        "fi": "Karapellontien päässä Keran juna-aseman jalankulkutunnelin luona oleva P-alue. "
                    },
                    "fullAddress": "Karapellontie 13, 02610 Espoo",
                    "homeLocationGroupId": 0,
                    "neighborhood": "Karamalmi",
                    "postalCode": "02610",
                    "notes": "",
                    "charger": "",
                    "inside": false
                },
                "pricingData": {
                    "base": {
                        "additionalDriver": 500,
                        "cancellationInsurance": 500,
                        "discount": 0,
                        "export": 2000,
                        "fiveHundredGramsCOTwo": null,
                        "freeKilometers": 0,
                        "freeKilometersType": null,
                        "handTruck": 0,
                        "highDeductible": 0,
                        "hundredTwentyFiveGramsCOTwo": null,
                        "includesHastinessFee": false,
                        "includesPickupTimeFee": false,
                        "includesReturnTimeFee": false,
                        "lowDeductible": 2500,
                        "pricePerKilometer": 5,
                        "savingOpportunities": [],
                        "sevenHundredGramsCOTwo": null,
                        "tireInsurance": 300,
                        "totalPrice": 26700,
                        "towHitch": 900,
                        "unlimitedKilometers": 1500,
                        "unlimitedKilometersForPolos": null,
                        "vehiclePrice": 24700,
                        "visibility": 1,
                        "windshieldInsurance": 400
                    },
                    "withCoupon": null,
                    "coupon": null,
                    "nonMember": null
                },
                "tagCloud": [
                    "eurooppa",
                    "tanska",
                    "norja",
                    "skandinavia",
                    "ruotsi",
                    "dieselkäyttöinen",
                    "vetokoukku",
                    "pakettiauto",
                    "käsivaihteinen"
                ],
                "vehicleData": {
                    "id": 1665,
                    "acriss": "",
                    "airbagCount": 5,
                    "brakedTowingCapacity": 2500,
                    "class": 2,
                    "co2Emissions": 218,
                    "consumptionInCity": 11,
                    "consumptionOnRoad": 9,
                    "combinedConsumption": 10,
                    "currentDistanceToHome": 16326,
                    "currentMileage": 11740,
                    "currentVoltage": 12.36,
                    "currentVoltageOk": true,
                    "deductible": {
                        "highDeductiblePrice": 0,
                        "highDeductibleValue": 180000,
                        "lowDeductiblePrice": 0,
                        "lowDeductibleValue": 90000
                    },
                    "doorCount": 5,
                    "engineDisplacement": 2,
                    "enginePower": 96,
                    "exportPermits": {
                        "balticStates": false,
                        "europe": true,
                        "scandinavia": true
                    },
                    "fixingPointCount": 14,
                    "fuelType": 0,
                    "hasAbs": true,
                    "hasAirConditioning": true,
                    "hasAutomaticTransmission": false,
                    "hasCdPlayer": false,
                    "hasCruiseControl": true,
                    "hasHandtruck": true,
                    "hasHeater": true,
                    "hasHelsinkiParkingPermit": false,
                    "hasHitch": true,
                    "hasNerfBars": true,
                    "hasRadio": true,
                    "hasTractionControl": true,
                    "homeAddress": "Valuraudantie 11, 00700 Helsinki",
                    "hybridity": "normal",
                    "hitchPinCount": 13,
                    "isGpsReliable": true,
                    "loadCapacity": 1293,
                    "modelYear": 2022,
                    "notesInEnglish": "",
                    "notesInFinnish": "",
                    "priceForExtension": 20,
                    "pricePerKilometer": 5,
                    "registrationNumber": "JIZ-180",
                    "seatCount": 3,
                    "tieDownPoints": 0,
                    "totalMass": 3500,
                    "type": 0,
                    "tyreType": "nasta",
                    "unbrakedTowingCapacity": 750,
                    "vehicleModel": {
                        "id": 76,
                        "dimensions": {
                            "trunkDepth": 353,
                            "trunkHeight": 188,
                            "trunkVolume": 11,
                            "trunkWidth": 178,
                            "vehicleHeight": 260,
                            "vehicleLength": 598,
                            "vehicleWidth": 250
                        },
                        "drivingLicenseRequirement": "B",
                        "manufacturer": "Ford",
                        "modelacriss": "",
                        "name": "Transit hybrid",
                        "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                        "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                        "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                        "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                        "type": "van"
                    }
                },
                "vehicleModelData": {
                    "id": 76,
                    "dimensions": {
                        "trunkDepth": 353,
                        "trunkHeight": 188,
                        "trunkVolume": 11,
                        "trunkWidth": 178,
                        "vehicleHeight": 260,
                        "vehicleLength": 598,
                        "vehicleWidth": 250
                    },
                    "drivingLicenseRequirement": "B",
                    "manufacturer": "Ford",
                    "modelacriss": "",
                    "name": "Transit hybrid",
                    "descr": "Ford Transit mHEV on erittäin hyvin varusteltu ja laadukas pakettiauto myös vaativiin kuljetustarpeisiin. Kevythybriditeknologia vähentää polttoainekulutusta ja tekee ajamisesta ekologisempaa!\n\nVarustettu mm. kaistavahdilla, peruutuskameralla, sähkötoimisesti taitettavilla sivupeileillä ja 8” värikosketusnäytöllä ja led-valaistulla tavaratilalla työvaloineen.",
                    "descren": "Ford Transit is very comfortable and high quality mild-hybrid van even for bigger transportation needs.\n\nEquipped with rear view camera and 8\" touch screen.",
                    "notes": "- Huomioi ajoneuvon korkeus: AUTO EI MAHDU USEIMPIIN PARKKIHALLEIHIN! \n\n- Keskipenkin istuinosa aukeaa nostamalla ensin etureunasta ja sen jälkeen kääntyy auki nostamalla takareunasta ylöspäin",
                    "notesen": "- Tall vehicle! IT'S NOT SUITABLE FOR MOST PARKING GARAGES!\n\n- Middle seat can be opened by lifting from the front side first and then lifting from the rear.",
                    "type": "van"
                },
                "servicesMaxChargeableDays": {
                    "1023": 14,
                    "1026": 14,
                    "1027": 1000,
                    "1028": 14,
                    "1029": 1000,
                    "1030": 1000,
                    "1038": 14,
                    "1039": 1000,
                    "1040": 3,
                    "1041": 7,
                    "1047": 1000,
                    "1048": 1000,
                    "1049": 1000
                },
                "privateData": {
                    "private": false,
                    "messageFi": "",
                    "messageEn": ""
                },
                "vehicleImages": [
                    {
                        "imageNumber": 1,
                        "imageName": "1403_76_1_large.webp"
                    },
                    {
                        "imageNumber": 2,
                        "imageName": "1403_76_2_large.webp"
                    },
                    {
                        "imageNumber": 3,
                        "imageName": "1403_76_3_large.webp"
                    },
                    {
                        "imageNumber": 4,
                        "imageName": "1403_76_4_large.webp"
                    }
                ]
            }
        ]
    }

    export const couponData = {
            "id": 7067,
            "datecreated": "2023-05-09 10:15:01",
            "dateupdated": "2023-05-09 10:17:56",
            "userid": 133,
            "active": 1,
            "backend": 0,
            "code": "F1DAJNS",
            "category": "Kumppani",
            "descr": "Fidan ilmainen paku 2023",
            "customertrusted": 0,
            "datelastused": "0000-00-00 00:00:00",
            "countUsed": 0,
            "countTotal": 2,
            "hasNumberUsedCountedPerCustomer": 0,
            "type": 1,
            "amount": "100.00",
            "target": 1,
            "triggerEmail": "",
            "triggerPhone": "",
            "triggerCustomerid": 0,
            "resWd1": 0,
            "resWd2": 0,
            "resWd3": 0,
            "resWd4": 0,
            "resWd5": 0,
            "resWd6": 0,
            "resWd7": 0,
            "resDateStart": "",
            "resDateEnd": "",
            "resTimeStart": "",
            "resTimeEnd": "",
            "resIgnorableFirstHours": 0,
            "resLength": "",
            "resLengthmax": "24",
            "resLengthmin": "",
            "resKmfree": 100,
            "resIsFreeKmPerDay": 1,
            "validDateStart": "",
            "validDateEnd": "",
            "validTimeStart": "",
            "validTimeEnd": "",
            "targetVehicleid": 0,
            "targetVehiclehomelocationid": 0,
            "targetCityid": 0,
            "targetVehiclemodeltypeid": 0,
            "targetVehicletypes": 0,
            "targetVehicleidMulti": "",
            "targetVehiclehomelocationidMulti": "7278",
            "idContract": null,
            "isDefault": null
    }

    export const oneWayRoutesData = {
        "Espoo": [
            "Oulu",
            "H\u00E4meenlinna",
            "Tampere",
            "Helsinki",
            "Vantaa",
            "Jyv\u00E4skyl\u00E4",
            "Joensuu",
            "Mikkeli",
            "Kuopio",
            "Turku",
            "Rovaniemi",
            "Lahti"
        ],
        "Oulu": [
            "Espoo",
            "Helsinki",
            "Lahti",
            "Mikkeli",
            "Turku",
            "Tampere",
            "Jyv\u00E4skyl\u00E4",
            "Kuopio",
            "Rovaniemi",
            "Vaasa"
        ],
        "Rovaniemi": [
            "Espoo",
            "Oulu",
            "Salo",
            "Vaasa",
            "Lahti",
            "H\u00E4meenlinna",
            "Turku",
            "Helsinki"
        ],
        "Helsinki": [
            "Turku",
            "Tampere",
            "Lahti",
            "Oulu",
            "Kuopio",
            "Rovaniemi",
            "Mikkeli",
            "Jyv\u00E4skyl\u00E4",
            "Vaasa",
            "Espoo",
            "Vantaa",
            "Joensuu",
            "Kotka",
            "Salo",
            "Pori"
        ],
        "Tampere": [
            "Pori",
            "Turku",
            "Kuopio",
            "Helsinki",
            "Oulu",
            "Jyv\u00E4skyl\u00E4",
            "Rovaniemi"
        ],
        "Joensuu": [
            "Helsinki",
            "Vaasa",
            "Turku",
            "Tampere",
            "Espoo",
            "Oulu",
            "Jyv\u00E4skyl\u00E4",
            "Mikkeli",
            "Kuopio"
        ],
        "Vaasa": [
            "Joensuu"
        ],
        "Mikkeli": [
            "Kuopio",
            "Helsinki"
        ],
        "Kuopio": [
            "Turku",
            "Helsinki",
            "Espoo",
            "Vantaa",
            "Oulu",
            "Tampere",
            "Jyv\u00E4skyl\u00E4",
            "Joensuu",
            "Mikkeli"
        ],
        "Turku": [
            "Kuopio",
            "Helsinki",
            "Espoo",
            "Vantaa",
            "Oulu",
            "Tampere",
            "Jyv\u00E4skyl\u00E4",
            "Joensuu",
            "Mikkeli",
            "Salo"
        ],
        "Jyv\u00E4skyl\u00E4": [
            "Oulu",
            "Turku",
            "Tampere",
            "Helsinki",
            "Vaasa",
            "Joensuu",
            "Kuopio",
            "Lahti"
        ],
        "Kerava": [
            "Helsinki",
            "Hyvink\u00E4\u00E4"
        ],
        "Vantaa": [
            "Turku",
            "Tampere",
            "Rovaniemi",
            "Oulu",
            "Jyv\u00E4skyl\u00E4",
            "Helsinki",
            "Espoo",
            "Joensuu",
            "Mikkeli",
            "Kuopio"
        ],
        "Hyvink\u00E4\u00E4": [
            "Riihim\u00E4ki"
        ],
        "H\u00E4meenlinna": [
            "Tampere"
        ],
        "Lahti": [
            "Vantaa"
        ],
        "Kotka": [
            "Vantaa"
        ]
    }